/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppRouteImport } from './routes/app/_layout'
import { Route as SuperAdminRouteImport } from './routes/superadmin/_layout'
import { Route as AdminRouteImport } from './routes/admin/_layout'
import { Route as IndexImport } from './routes/index'
import { Route as AboutImport } from './routes/about'
import { Route as PricingImport } from './routes/pricing'
import { Route as ContactImport } from './routes/contact'
import { Route as HelpImport } from './routes/help'
import { Route as ProductImport } from './routes/product'
import { Route as SecurityImport } from './routes/security'
import { Route as CustomersImport } from './routes/customers'
import { Route as StatusImport } from './routes/status'
import { Route as ChangelogImport } from './routes/changelog'
import { Route as CareersImport } from './routes/careers'
import { Route as DocsImport } from './routes/docs'
import { Route as DocsGettingStartedImport } from './routes/docs/getting-started'
import { Route as DocsOnboardingTrustImport } from './routes/docs/onboarding-a-trust'
import { Route as DocsSigningFlowImport } from './routes/docs/signing-flow'
import { Route as BrandbookImport } from './routes/brandbook'
import { Route as FirmsImport } from './routes/firms'
import { Route as AuthLoginImport } from './routes/auth/login'
import { Route as AuthSignupImport } from './routes/auth/signup'
import { Route as AuthForgotImport } from './routes/auth/forgot'
import { Route as AuthResetPasswordImport } from './routes/auth/reset-password'
import { Route as AuthCheckEmailImport } from './routes/auth/check-email'
import { Route as AuthWorkspaceInviteImport } from './routes/auth/workspace-invite'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as AuthRecoveryImport } from './routes/auth/recovery'
import { Route as AuthRecoveryLostBothImport } from './routes/auth/recovery/lost-both'
import { Route as AuthRecoveryStatusImport } from './routes/auth/recovery/status'
import { Route as SignExternalTokenImport } from './routes/sign/external/$token'
import { Route as SignExternalReturnImport } from './routes/sign/external/return'
import { Route as AuthMfaEnrollImport } from './routes/auth/mfa-enroll'
import { Route as AuthMfaVerifyImport } from './routes/auth/mfa-verify'
import { Route as AuthRefreshStepUpImport } from './routes/auth/refresh-step-up'
import { Route as LegalPrivacyImport } from './routes/legal/privacy'
import { Route as LegalPaiaImport } from './routes/legal/paia'
import { Route as LegalTermsImport } from './routes/legal/terms'
import { Route as PartnerFinderDashboardImport } from './routes/partner/finder-dashboard'
import { Route as LegalCookiesImport } from './routes/legal/cookies'
import { Route as LegalTrustCentreImport } from './routes/legal/trust-centre'
import { Route as LegalSubprocessorsImport } from './routes/legal/subprocessors'
import { Route as LegalSecurityImport } from './routes/legal/security'
import { Route as LegalDpaImport } from './routes/legal/dpa'
import { Route as ComplianceRouteImport } from './routes/compliance/_layout'
import { Route as ComplianceFicaImport } from './routes/compliance/fica'
import { Route as CompliancePopiaImport } from './routes/compliance/popia'
// AUDITOR-01 (2026-06-10): external-auditor read-only surface — hand-wired
// (no regen) so custom URLs elsewhere in this file are preserved.
import { Route as AuditRouteImport } from './routes/audit/_layout'
import { Route as AuditIndexImport } from './routes/audit/index'
import { Route as AuditTrustIdImport } from './routes/audit/$trustId'
// Legacy flat-route redirects (still exist as files)
import { Route as AppTrustImport } from './routes/app/trust'
import { Route as AppTaxImport } from './routes/app/tax'
import { Route as AppMessagesImport } from './routes/app/messages'
import { Route as AppDocumentsImport } from './routes/app/documents'
import { Route as AppDistributionsImport } from './routes/app/distributions'
import { Route as AppAuditImport } from './routes/app/audit'
import { Route as AppResolutionsIndexImport } from './routes/app/resolutions/index'
import { Route as AppBeneficiariesIndexImport } from './routes/app/beneficiaries/index'
import { Route as AppBeneficiariesOwnershipImport } from './routes/app/beneficiaries/ownership'
import { Route as AppResolutionsIdSignImport } from './routes/app/resolutions/$id/sign'
// New cross-trust global routes
import { Route as AppDashboardImport } from './routes/app/dashboard'
// Document-first account setup (2026-06-20) — store-driven step machine, lazy body.
import { Route as AppStructureImport } from './routes/app/structure'
import { Route as AppInboxImport } from './routes/app/inbox'
import { Route as AppSecurityImport } from './routes/app/security'
import { Route as AppFirmAccessImport } from './routes/app/firm-access'
import { Route as AppProfileImport } from './routes/app/profile'
import { Route as AppPrivacyImport } from './routes/app/privacy'
// New trust-list route
import { Route as AppTrustsIndexImport } from './routes/app/trusts/index'
// New trust-scoped routes (under /app/trusts/$id/)
import { Route as AppTrustsIdIndexImport } from './routes/app/trusts/$id/index'
import { Route as AppTrustsIdDistributionsImport } from './routes/app/trusts/$id/distributions'
import { Route as AppTrustsIdTaxImport } from './routes/app/trusts/$id/tax'
import { Route as AppTrustsIdAuditImport } from './routes/app/trusts/$id/audit'
import { Route as AppTrustsIdDocumentsImport } from './routes/app/trusts/$id/documents'
import { Route as AppTrustsIdPortfoliosImport } from './routes/app/trusts/$id/portfolios'
// Batch 18 / A3 (2026-05-20) — B2C trustee asset entry.
import { Route as AppTrustsIdPropertiesImport } from './routes/app/trusts/$id/properties'
import { Route as AppTrustsIdCompaniesImport } from './routes/app/trusts/$id/companies'
// §16 (Wave C) — recognised-assets tab + company assets view.
import { Route as AppTrustsIdAssetsImport } from './routes/app/trusts/$id/assets'
import { Route as AppTrustsIdCompaniesCompanyIdImport } from './routes/app/trusts/$id/companies.$companyId'
import { Route as AppTrustsIdMeetingsImport } from './routes/app/trusts/$id/meetings'
import { Route as AppTrustsIdMeetingsNewImport } from './routes/app/trusts/$id/meetings.new'
import { Route as AppTrustsIdLoaLowImport } from './routes/app/trusts/$id/loa-low'
import { Route as AppTrustsIdRiskRatingImport } from './routes/app/trusts/$id/risk-rating'
import { Route as AppTrustsIdSettingsImport } from './routes/app/trusts/$id/settings'
import { Route as AppTrustsIdPeopleIndexImport } from './routes/app/trusts/$id/people'
import { Route as AppTrustsIdBeneficiariesIndexImport } from './routes/app/trusts/$id/beneficiaries/index'
import { Route as AppTrustsIdBeneficiaryOwnershipImport } from './routes/app/trusts/$id/beneficiaries/ownership'
import { Route as AppTrustsIdResolutionsIndexImport } from './routes/app/trusts/$id/resolutions/index'
import { Route as AppTrustsIdResolutionsRidSignImport } from './routes/app/trusts/$id/resolutions/$rid/sign'
import { Route as AppTrustsIdResolutionsRidIndexImport } from './routes/app/trusts/$id/resolutions/$rid/index'
// WS-4 (2026-06-19) — document-review (ingestion confirm) sub-route.
import { Route as AppTrustsIdDocumentReviewJobIdImport } from './routes/app/trusts/$id/document-review.$jobId'
import { Route as SuperAdminIndexImport } from './routes/superadmin/index'
import { Route as SuperAdminTiersImport } from './routes/superadmin/tiers'
import { Route as SuperAdminRecoveryImport } from './routes/superadmin/recovery'
import { Route as SuperAdminAuditImport } from './routes/superadmin/audit'
import { Route as SuperAdminSubprocessorsImport } from './routes/superadmin/subprocessors'
import { Route as SuperAdminSettingsImport } from './routes/superadmin/settings'
import { Route as SuperAdminTenantsIndexImport } from './routes/superadmin/tenants/index'
import { Route as SuperAdminTenantsIdImport } from './routes/superadmin/tenants/$id'
// Phase 9 final-stub superadmin routes
import { Route as SuperAdminSentinelRulesImport } from './routes/superadmin/sentinel-rules'
import { Route as SuperAdminHealthImport } from './routes/superadmin/health'
import { Route as SuperAdminPricingImport } from './routes/superadmin/pricing'
import { Route as SuperAdminFeaturesImport } from './routes/superadmin/features'
import { Route as AdminDashboardImport } from './routes/admin/dashboard'
import { Route as AdminClientBookImport } from './routes/admin/client-book'
import { Route as AdminBrandingImport } from './routes/admin/branding'
import { Route as AdminClientsIndexImport } from './routes/admin/clients/index'
import { Route as AdminClientsIdImport } from './routes/admin/clients/$id'
import { Route as AdminTeamImport } from './routes/admin/team'
import { Route as AdminBillingImport } from './routes/admin/billing'
import { Route as AdminPartnerEarningsImport } from './routes/admin/partner-earnings'
import { Route as AdminIntegrationsImport } from './routes/admin/integrations'
import { Route as AdminAuditImport } from './routes/admin/audit'
import { Route as AdminEntityGraphImport } from './routes/admin/entity-graph'
import { Route as AdminDsarImport } from './routes/admin/dsar'
import { Route as AdminComplianceReportsImport } from './routes/admin/compliance-reports'
import { Route as AdminRecoveryRequestsImport } from './routes/admin/recovery-requests'
import { Route as AdminExternalAuditorsImport } from './routes/admin/external-auditors'
import { Route as AdminMasterLodgementsImport } from './routes/admin/master-lodgements'
// P2-3 — firm-wide missing-documents dashboard
import { Route as AdminDocumentCoverageImport } from './routes/admin/document-coverage'
// doc-organization — firm-wide documents browser
import { Route as AdminDocumentsImport } from './routes/admin/documents'
// Phase 9 final-stub admin routes
import { Route as AdminQueueImport } from './routes/admin/queue'
import { Route as AdminTrustsImport } from './routes/admin/trusts'
import { Route as AdminFicaImport } from './routes/admin/fica'
// Phase 9 P1 routes
import { Route as AdminFicReportsImport } from './routes/admin/fic-reports'
import { Route as AdminFicReportsNewImport } from './routes/admin/fic-reports.new'
import { Route as AdminFicReportsIdImport } from './routes/admin/fic-reports.$id'
import { Route as AdminRiskReviewImport } from './routes/admin/risk-review'
import { Route as AdminEddImport } from './routes/admin/edd'
import { Route as AdminEddIdImport } from './routes/admin/edd.$id'
import { Route as AdminAesSyncLogImport } from './routes/admin/aes-sync-log'
import { Route as AdminLegalHoldsImport } from './routes/admin/legal-holds'
import { Route as AdminBrandingCustomDomainImport } from './routes/admin/branding.custom-domain'
// Onboarding routes
import { Route as OnboardingFirmImport } from './routes/onboarding/firm'
import { Route as OnboardingIndividualImport } from './routes/onboarding/individual'
import { Route as OnboardingInvitedImport } from './routes/onboarding/invited'

// Create/Update Routes

const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as never)

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as never)

const SuperAdminRoute = SuperAdminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => rootRoute,
} as never)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as never)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as never)

const PricingRoute = PricingImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRoute,
} as never)

const ContactRoute = ContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as never)

const HelpRoute = HelpImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRoute,
} as never)

const ProductRoute = ProductImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => rootRoute,
} as never)

const SecurityRoute = SecurityImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRoute,
} as never)

const CustomersRoute = CustomersImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRoute,
} as never)

const StatusRoute = StatusImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRoute,
} as never)

const ChangelogRoute = ChangelogImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRoute,
} as never)

const CareersRoute = CareersImport.update({
  id: '/careers',
  path: '/careers',
  getParentRoute: () => rootRoute,
} as never)

const DocsRoute = DocsImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRoute,
} as never)

const DocsGettingStartedRoute = DocsGettingStartedImport.update({
  id: '/docs/getting-started',
  path: '/docs/getting-started',
  getParentRoute: () => rootRoute,
} as never)

const DocsOnboardingTrustRoute = DocsOnboardingTrustImport.update({
  id: '/docs/onboarding-a-trust',
  path: '/docs/onboarding-a-trust',
  getParentRoute: () => rootRoute,
} as never)

const DocsSigningFlowRoute = DocsSigningFlowImport.update({
  id: '/docs/signing-flow',
  path: '/docs/signing-flow',
  getParentRoute: () => rootRoute,
} as never)

const BrandbookRoute = BrandbookImport.update({
  id: '/brandbook',
  path: '/brandbook',
  getParentRoute: () => rootRoute,
} as never)

const FirmsRoute = FirmsImport.update({
  id: '/firms',
  path: '/firms',
  getParentRoute: () => rootRoute,
} as never)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRoute,
} as never)

const AuthSignupRoute = AuthSignupImport.update({
  id: '/auth/signup',
  path: '/auth/signup',
  getParentRoute: () => rootRoute,
} as never)

const AuthForgotRoute = AuthForgotImport.update({
  id: '/auth/forgot',
  path: '/auth/forgot',
  getParentRoute: () => rootRoute,
} as never)

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRoute,
} as never)

const AuthCheckEmailRoute = AuthCheckEmailImport.update({
  id: '/auth/check-email',
  path: '/auth/check-email',
  getParentRoute: () => rootRoute,
} as never)

const AuthWorkspaceInviteRoute = AuthWorkspaceInviteImport.update({
  id: '/auth/workspace-invite',
  path: '/auth/workspace-invite',
  getParentRoute: () => rootRoute,
} as never)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as never)

const AuthRecoveryRoute = AuthRecoveryImport.update({
  id: '/auth/recovery',
  path: '/auth/recovery',
  getParentRoute: () => rootRoute,
} as never)

const AuthMfaEnrollRoute = AuthMfaEnrollImport.update({
  id: '/auth/mfa-enroll',
  path: '/auth/mfa-enroll',
  getParentRoute: () => rootRoute,
} as never)

const AuthMfaVerifyRoute = AuthMfaVerifyImport.update({
  id: '/auth/mfa-verify',
  path: '/auth/mfa-verify',
  getParentRoute: () => rootRoute,
} as never)

const AuthRefreshStepUpRoute = AuthRefreshStepUpImport.update({
  id: '/auth/refresh-step-up',
  path: '/auth/refresh-step-up',
  getParentRoute: () => rootRoute,
} as never)

const AuthRecoveryLostBothRoute = AuthRecoveryLostBothImport.update({
  id: '/auth/recovery/lost-both',
  path: '/auth/recovery/lost-both',
  getParentRoute: () => rootRoute,
} as never)

const AuthRecoveryStatusRoute = AuthRecoveryStatusImport.update({
  id: '/auth/recovery/status',
  path: '/auth/recovery/status',
  getParentRoute: () => rootRoute,
} as never)

const SignExternalTokenRoute = SignExternalTokenImport.update({
  id: '/sign/external/$token',
  path: '/sign/external/$token',
  getParentRoute: () => rootRoute,
} as never)

const SignExternalReturnRoute = SignExternalReturnImport.update({
  id: '/sign/external/return',
  path: '/sign/external/return',
  getParentRoute: () => rootRoute,
} as never)

const LegalPrivacyRoute = LegalPrivacyImport.update({
  id: '/legal/privacy',
  path: '/legal/privacy',
  getParentRoute: () => rootRoute,
} as never)

const LegalPaiaRoute = LegalPaiaImport.update({
  id: '/legal/paia',
  path: '/legal/paia',
  getParentRoute: () => rootRoute,
} as never)

const LegalTermsRoute = LegalTermsImport.update({
  id: '/legal/terms',
  path: '/legal/terms',
  getParentRoute: () => rootRoute,
} as never)

const PartnerFinderDashboardRoute = PartnerFinderDashboardImport.update({
  id: '/partner/finder-dashboard',
  path: '/partner/finder-dashboard',
  getParentRoute: () => rootRoute,
} as never)

const LegalCookiesRoute = LegalCookiesImport.update({
  id: '/legal/cookies',
  path: '/legal/cookies',
  getParentRoute: () => rootRoute,
} as never)

const LegalTrustCentreRoute = LegalTrustCentreImport.update({
  id: '/legal/trust-centre',
  path: '/legal/trust-centre',
  getParentRoute: () => rootRoute,
} as never)

const LegalSubprocessorsRoute = LegalSubprocessorsImport.update({
  id: '/legal/subprocessors',
  path: '/legal/subprocessors',
  getParentRoute: () => rootRoute,
} as never)

const LegalSecurityRoute = LegalSecurityImport.update({
  id: '/legal/security',
  path: '/legal/security',
  getParentRoute: () => rootRoute,
} as never)

const LegalDpaRoute = LegalDpaImport.update({
  id: '/legal/dpa',
  path: '/legal/dpa',
  getParentRoute: () => rootRoute,
} as never)

const ComplianceRoute = ComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => rootRoute,
} as never)

const ComplianceFicaRoute = ComplianceFicaImport.update({
  id: '/fica',
  path: '/fica',
  getParentRoute: () => ComplianceRoute,
} as never)

const CompliancePopiaRoute = CompliancePopiaImport.update({
  id: '/popia',
  path: '/popia',
  getParentRoute: () => ComplianceRoute,
} as never)

// AUDITOR-01: /audit parent layout (gate + shell) + index + $trustId drill-down.
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRoute,
} as never)

const AuditIndexRoute = AuditIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuditRoute,
} as never)

const AuditTrustIdRoute = AuditTrustIdImport.update({
  id: '/$trustId',
  path: '/$trustId',
  getParentRoute: () => AuditRoute,
} as never)

// ── Legacy redirect routes (flat /app/* → trust-scoped) ──────────────────────

const AppTrustRoute = AppTrustImport.update({
  id: '/trust',
  path: '/trust',
  getParentRoute: () => AppRoute,
} as never)

const AppTaxRoute = AppTaxImport.update({
  id: '/tax',
  path: '/tax',
  getParentRoute: () => AppRoute,
} as never)

const AppMessagesRoute = AppMessagesImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as never)

const AppDocumentsRoute = AppDocumentsImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as never)

const AppDistributionsRoute = AppDistributionsImport.update({
  id: '/distributions',
  path: '/distributions',
  getParentRoute: () => AppRoute,
} as never)

const AppAuditRoute = AppAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as never)

const AppResolutionsIndexRoute = AppResolutionsIndexImport.update({
  id: '/resolutions/',
  path: '/resolutions/',
  getParentRoute: () => AppRoute,
} as never)

const AppBeneficiariesIndexRoute = AppBeneficiariesIndexImport.update({
  id: '/beneficiaries/',
  path: '/beneficiaries/',
  getParentRoute: () => AppRoute,
} as never)

const AppBeneficiariesOwnershipRoute = AppBeneficiariesOwnershipImport.update({
  id: '/beneficiaries/ownership',
  path: '/beneficiaries/ownership',
  getParentRoute: () => AppRoute,
} as never)

const AppResolutionsIdSignRoute = AppResolutionsIdSignImport.update({
  id: '/resolutions/$id/sign',
  path: '/resolutions/$id/sign',
  getParentRoute: () => AppRoute,
} as never)

// ── Cross-trust global routes ─────────────────────────────────────────────────

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as never)

// Path A: firm maps an existing client's structure (2026-07-02).
const AppStructureRoute = AppStructureImport.update({
  id: '/structure',
  path: '/structure',
  getParentRoute: () => AppRoute,
} as never)

const AppInboxRoute = AppInboxImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as never)

const AppSecurityRoute = AppSecurityImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppRoute,
} as never)

const AppFirmAccessRoute = AppFirmAccessImport.update({
  id: '/firm-access',
  path: '/firm-access',
  getParentRoute: () => AppRoute,
} as never)

const AppProfileRoute = AppProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as never)

const AppPrivacyRoute = AppPrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppRoute,
} as never)

// ── Trust list ────────────────────────────────────────────────────────────────

const AppTrustsIndexRoute = AppTrustsIndexImport.update({
  id: '/trusts/',
  path: '/trusts/',
  getParentRoute: () => AppRoute,
} as never)

// ── Trust-scoped routes (/app/trusts/$id/*) ───────────────────────────────────

const AppTrustsIdIndexRoute = AppTrustsIdIndexImport.update({
  id: '/trusts/$id/',
  path: '/trusts/$id/',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdDistributionsRoute = AppTrustsIdDistributionsImport.update({
  id: '/trusts/$id/distributions',
  path: '/trusts/$id/distributions',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdTaxRoute = AppTrustsIdTaxImport.update({
  id: '/trusts/$id/tax',
  path: '/trusts/$id/tax',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdAuditRoute = AppTrustsIdAuditImport.update({
  id: '/trusts/$id/audit',
  path: '/trusts/$id/audit',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdDocumentsRoute = AppTrustsIdDocumentsImport.update({
  id: '/trusts/$id/documents',
  path: '/trusts/$id/documents',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdPortfoliosRoute = AppTrustsIdPortfoliosImport.update({
  id: '/trusts/$id/portfolios',
  path: '/trusts/$id/portfolios',
  getParentRoute: () => AppRoute,
} as never)

// Batch 18 / A3 (2026-05-20) — B2C trustee asset entry.
const AppTrustsIdPropertiesRoute = AppTrustsIdPropertiesImport.update({
  id: '/trusts/$id/properties',
  path: '/trusts/$id/properties',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdCompaniesRoute = AppTrustsIdCompaniesImport.update({
  id: '/trusts/$id/companies',
  path: '/trusts/$id/companies',
  getParentRoute: () => AppRoute,
} as never)

// §16 (Wave C) — recognised-assets tab + company assets view.
const AppTrustsIdAssetsRoute = AppTrustsIdAssetsImport.update({
  id: '/trusts/$id/assets',
  path: '/trusts/$id/assets',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdCompaniesCompanyIdRoute =
  AppTrustsIdCompaniesCompanyIdImport.update({
    id: '/trusts/$id/companies/$companyId',
    path: '/trusts/$id/companies/$companyId',
    getParentRoute: () => AppRoute,
  } as never)

const AppTrustsIdMeetingsRoute = AppTrustsIdMeetingsImport.update({
  id: '/trusts/$id/meetings',
  path: '/trusts/$id/meetings',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdMeetingsNewRoute = AppTrustsIdMeetingsNewImport.update({
  id: '/trusts/$id/meetings/new',
  path: '/trusts/$id/meetings/new',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdLoaLowRoute = AppTrustsIdLoaLowImport.update({
  id: '/trusts/$id/loa-low',
  path: '/trusts/$id/loa-low',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdRiskRatingRoute = AppTrustsIdRiskRatingImport.update({
  id: '/trusts/$id/risk-rating',
  path: '/trusts/$id/risk-rating',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdSettingsRoute = AppTrustsIdSettingsImport.update({
  id: '/trusts/$id/settings',
  path: '/trusts/$id/settings',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdPeopleIndexRoute = AppTrustsIdPeopleIndexImport.update({
  id: '/trusts/$id/people/',
  path: '/trusts/$id/people/',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdBeneficiariesIndexRoute = AppTrustsIdBeneficiariesIndexImport.update({
  id: '/trusts/$id/beneficiaries/',
  path: '/trusts/$id/beneficiaries/',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdBeneficiaryOwnershipRoute = AppTrustsIdBeneficiaryOwnershipImport.update({
  id: '/trusts/$id/beneficial-ownership',
  path: '/trusts/$id/beneficial-ownership',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdResolutionsIndexRoute = AppTrustsIdResolutionsIndexImport.update({
  id: '/trusts/$id/resolutions/',
  path: '/trusts/$id/resolutions/',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdResolutionsRidSignRoute = AppTrustsIdResolutionsRidSignImport.update({
  id: '/trusts/$id/resolutions/$rid/sign',
  path: '/trusts/$id/resolutions/$rid/sign',
  getParentRoute: () => AppRoute,
} as never)

const AppTrustsIdResolutionsRidIndexRoute = AppTrustsIdResolutionsRidIndexImport.update({
  id: '/trusts/$id/resolutions/$rid/',
  path: '/trusts/$id/resolutions/$rid/',
  getParentRoute: () => AppRoute,
} as never)

// WS-4 (2026-06-19) — document-review (ingestion confirm) sub-route.
const AppTrustsIdDocumentReviewJobIdRoute =
  AppTrustsIdDocumentReviewJobIdImport.update({
    id: '/trusts/$id/document-review/$jobId',
    path: '/trusts/$id/document-review/$jobId',
    getParentRoute: () => AppRoute,
  } as never)

// ── SuperAdmin routes ─────────────────────────────────────────────────────────

const SuperAdminIndexRoute = SuperAdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminTiersRoute = SuperAdminTiersImport.update({
  id: '/tiers',
  path: '/tiers',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminRecoveryRoute = SuperAdminRecoveryImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminAuditRoute = SuperAdminAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminSubprocessorsRoute = SuperAdminSubprocessorsImport.update({
  id: '/subprocessors',
  path: '/subprocessors',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminSettingsRoute = SuperAdminSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminTenantsIndexRoute = SuperAdminTenantsIndexImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminTenantsIdRoute = SuperAdminTenantsIdImport.update({
  id: '/tenants/$id',
  path: '/tenants/$id',
  getParentRoute: () => SuperAdminRoute,
} as never)

// ── Phase 9 final-stub superadmin routes ──────────────────────────────────────

const SuperAdminSentinelRulesRoute = SuperAdminSentinelRulesImport.update({
  id: '/sentinel-rules',
  path: '/sentinel-rules',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminHealthRoute = SuperAdminHealthImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminPricingRoute = SuperAdminPricingImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => SuperAdminRoute,
} as never)

const SuperAdminFeaturesRoute = SuperAdminFeaturesImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => SuperAdminRoute,
} as never)

// ── Admin routes ──────────────────────────────────────────────────────────────

const AdminDashboardRoute = AdminDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as never)

const AdminClientBookRoute = AdminClientBookImport.update({
  id: '/client-book',
  path: '/client-book',
  getParentRoute: () => AdminRoute,
} as never)

const AdminBrandingRoute = AdminBrandingImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AdminRoute,
} as never)

const AdminClientsIndexRoute = AdminClientsIndexImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AdminRoute,
} as never)

const AdminClientsIdRoute = AdminClientsIdImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => AdminRoute,
} as never)

const AdminTeamRoute = AdminTeamImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AdminRoute,
} as never)

const AdminBillingRoute = AdminBillingImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as never)

const AdminPartnerEarningsRoute = AdminPartnerEarningsImport.update({
  id: '/partner-earnings',
  path: '/partner-earnings',
  getParentRoute: () => AdminRoute,
} as never)

const AdminIntegrationsRoute = AdminIntegrationsImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AdminRoute,
} as never)

const AdminAuditRoute = AdminAuditImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as never)

const AdminEntityGraphRoute = AdminEntityGraphImport.update({
  id: '/entity-graph',
  path: '/entity-graph',
  getParentRoute: () => AdminRoute,
} as never)

const AdminDsarRoute = AdminDsarImport.update({
  id: '/dsar',
  path: '/dsar',
  getParentRoute: () => AdminRoute,
} as never)

const AdminComplianceReportsRoute = AdminComplianceReportsImport.update({
  id: '/compliance-reports',
  path: '/compliance-reports',
  getParentRoute: () => AdminRoute,
} as never)

const AdminRecoveryRequestsRoute = AdminRecoveryRequestsImport.update({
  id: '/recovery-requests',
  path: '/recovery-requests',
  getParentRoute: () => AdminRoute,
} as never)

const AdminExternalAuditorsRoute = AdminExternalAuditorsImport.update({
  id: '/external-auditors',
  path: '/external-auditors',
  getParentRoute: () => AdminRoute,
} as never)

const AdminMasterLodgementsRoute = AdminMasterLodgementsImport.update({
  id: '/master-lodgements',
  path: '/master-lodgements',
  getParentRoute: () => AdminRoute,
} as never)

const AdminDocumentCoverageRoute = AdminDocumentCoverageImport.update({
  id: '/document-coverage',
  path: '/document-coverage',
  getParentRoute: () => AdminRoute,
} as never)

const AdminDocumentsRoute = AdminDocumentsImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AdminRoute,
} as never)

// ── Phase 9 P1 admin routes ────────────────────────────────────────────────────

const AdminFicReportsRoute = AdminFicReportsImport.update({
  id: '/fic-reports',
  path: '/fic-reports',
  getParentRoute: () => AdminRoute,
} as never)

const AdminFicReportsNewRoute = AdminFicReportsNewImport.update({
  id: '/fic-reports/new',
  path: '/fic-reports/new',
  getParentRoute: () => AdminRoute,
} as never)

const AdminFicReportsIdRoute = AdminFicReportsIdImport.update({
  id: '/fic-reports/$id',
  path: '/fic-reports/$id',
  getParentRoute: () => AdminRoute,
} as never)

const AdminRiskReviewRoute = AdminRiskReviewImport.update({
  id: '/risk-review',
  path: '/risk-review',
  getParentRoute: () => AdminRoute,
} as never)

const AdminEddRoute = AdminEddImport.update({
  id: '/edd',
  path: '/edd',
  getParentRoute: () => AdminRoute,
} as never)

const AdminEddIdRoute = AdminEddIdImport.update({
  id: '/edd/$id',
  path: '/edd/$id',
  getParentRoute: () => AdminRoute,
} as never)

const AdminAesSyncLogRoute = AdminAesSyncLogImport.update({
  id: '/aes-sync-log',
  path: '/aes-sync-log',
  getParentRoute: () => AdminRoute,
} as never)

const AdminLegalHoldsRoute = AdminLegalHoldsImport.update({
  id: '/legal-holds',
  path: '/legal-holds',
  getParentRoute: () => AdminRoute,
} as never)

const AdminBrandingCustomDomainRoute = AdminBrandingCustomDomainImport.update({
  id: '/branding/custom-domain',
  path: '/branding/custom-domain',
  getParentRoute: () => AdminRoute,
} as never)

// ── Phase 9 final-stub admin routes ───────────────────────────────────────────

const AdminQueueRoute = AdminQueueImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AdminRoute,
} as never)

const AdminTrustsRoute = AdminTrustsImport.update({
  id: '/trusts',
  path: '/trusts',
  getParentRoute: () => AdminRoute,
} as never)

const AdminFicaRoute = AdminFicaImport.update({
  id: '/fica',
  path: '/fica',
  getParentRoute: () => AdminRoute,
} as never)

// ── Onboarding routes ─────────────────────────────────────────────────────────

const OnboardingFirmRoute = OnboardingFirmImport.update({
  id: '/onboarding/firm',
  path: '/onboarding/firm',
  getParentRoute: () => rootRoute,
} as never)

const OnboardingIndividualRoute = OnboardingIndividualImport.update({
  id: '/onboarding/individual',
  path: '/onboarding/individual',
  getParentRoute: () => rootRoute,
} as never)

const OnboardingInvitedRoute = OnboardingInvitedImport.update({
  id: '/onboarding/invited',
  path: '/onboarding/invited',
  getParentRoute: () => rootRoute,
} as never)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactImport
      parentRoute: typeof rootRoute
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpImport
      parentRoute: typeof rootRoute
    }
    '/product': {
      id: '/product'
      path: '/product'
      fullPath: '/product'
      preLoaderRoute: typeof ProductImport
      parentRoute: typeof rootRoute
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityImport
      parentRoute: typeof rootRoute
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersImport
      parentRoute: typeof rootRoute
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusImport
      parentRoute: typeof rootRoute
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogImport
      parentRoute: typeof rootRoute
    }
    '/careers': {
      id: '/careers'
      path: '/careers'
      fullPath: '/careers'
      preLoaderRoute: typeof CareersImport
      parentRoute: typeof rootRoute
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsImport
      parentRoute: typeof rootRoute
    }
    '/docs/getting-started': {
      id: '/docs/getting-started'
      path: '/docs/getting-started'
      fullPath: '/docs/getting-started'
      preLoaderRoute: typeof DocsGettingStartedImport
      parentRoute: typeof rootRoute
    }
    '/docs/onboarding-a-trust': {
      id: '/docs/onboarding-a-trust'
      path: '/docs/onboarding-a-trust'
      fullPath: '/docs/onboarding-a-trust'
      preLoaderRoute: typeof DocsOnboardingTrustImport
      parentRoute: typeof rootRoute
    }
    '/docs/signing-flow': {
      id: '/docs/signing-flow'
      path: '/docs/signing-flow'
      fullPath: '/docs/signing-flow'
      preLoaderRoute: typeof DocsSigningFlowImport
      parentRoute: typeof rootRoute
    }
    '/brandbook': {
      id: '/brandbook'
      path: '/brandbook'
      fullPath: '/brandbook'
      preLoaderRoute: typeof BrandbookImport
      parentRoute: typeof rootRoute
    }
    '/firms': {
      id: '/firms'
      path: '/firms'
      fullPath: '/firms'
      preLoaderRoute: typeof FirmsImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/superadmin': {
      id: '/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof SuperAdminRouteImport
      parentRoute: typeof rootRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof rootRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/auth/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupImport
      parentRoute: typeof rootRoute
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/auth/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotImport
      parentRoute: typeof rootRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/check-email': {
      id: '/auth/check-email'
      path: '/auth/check-email'
      fullPath: '/auth/check-email'
      preLoaderRoute: typeof AuthCheckEmailImport
      parentRoute: typeof rootRoute
    }
    '/auth/workspace-invite': {
      id: '/auth/workspace-invite'
      path: '/auth/workspace-invite'
      fullPath: '/auth/workspace-invite'
      preLoaderRoute: typeof AuthWorkspaceInviteImport
      parentRoute: typeof rootRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/auth/recovery': {
      id: '/auth/recovery'
      path: '/auth/recovery'
      fullPath: '/auth/recovery'
      preLoaderRoute: typeof AuthRecoveryImport
      parentRoute: typeof rootRoute
    }
    '/auth/recovery/lost-both': {
      id: '/auth/recovery/lost-both'
      path: '/auth/recovery/lost-both'
      fullPath: '/auth/recovery/lost-both'
      preLoaderRoute: typeof AuthRecoveryLostBothImport
      parentRoute: typeof rootRoute
    }
    '/auth/recovery/status': {
      id: '/auth/recovery/status'
      path: '/auth/recovery/status'
      fullPath: '/auth/recovery/status'
      preLoaderRoute: typeof AuthRecoveryStatusImport
      parentRoute: typeof rootRoute
    }
    '/sign/external/$token': {
      id: '/sign/external/$token'
      path: '/sign/external/$token'
      fullPath: '/sign/external/$token'
      preLoaderRoute: typeof SignExternalTokenImport
      parentRoute: typeof rootRoute
    }
    '/sign/external/return': {
      id: '/sign/external/return'
      path: '/sign/external/return'
      fullPath: '/sign/external/return'
      preLoaderRoute: typeof SignExternalReturnImport
      parentRoute: typeof rootRoute
    }
    '/auth/mfa-enroll': {
      id: '/auth/mfa-enroll'
      path: '/auth/mfa-enroll'
      fullPath: '/auth/mfa-enroll'
      preLoaderRoute: typeof AuthMfaEnrollImport
      parentRoute: typeof rootRoute
    }
    '/auth/mfa-verify': {
      id: '/auth/mfa-verify'
      path: '/auth/mfa-verify'
      fullPath: '/auth/mfa-verify'
      preLoaderRoute: typeof AuthMfaVerifyImport
      parentRoute: typeof rootRoute
    }
    '/auth/refresh-step-up': {
      id: '/auth/refresh-step-up'
      path: '/auth/refresh-step-up'
      fullPath: '/auth/refresh-step-up'
      preLoaderRoute: typeof AuthRefreshStepUpImport
      parentRoute: typeof rootRoute
    }
    '/legal/privacy': {
      id: '/legal/privacy'
      path: '/legal/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalPrivacyImport
      parentRoute: typeof rootRoute
    }
    '/legal/paia': {
      id: '/legal/paia'
      path: '/legal/paia'
      fullPath: '/legal/paia'
      preLoaderRoute: typeof LegalPaiaImport
      parentRoute: typeof rootRoute
    }
    '/legal/terms': {
      id: '/legal/terms'
      path: '/legal/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalTermsImport
      parentRoute: typeof rootRoute
    }
    '/partner/finder-dashboard': {
      id: '/partner/finder-dashboard'
      path: '/partner/finder-dashboard'
      fullPath: '/partner/finder-dashboard'
      preLoaderRoute: typeof PartnerFinderDashboardImport
      parentRoute: typeof rootRoute
    }
    '/legal/cookies': {
      id: '/legal/cookies'
      path: '/legal/cookies'
      fullPath: '/legal/cookies'
      preLoaderRoute: typeof LegalCookiesImport
      parentRoute: typeof rootRoute
    }
    '/legal/trust-centre': {
      id: '/legal/trust-centre'
      path: '/legal/trust-centre'
      fullPath: '/legal/trust-centre'
      preLoaderRoute: typeof LegalTrustCentreImport
      parentRoute: typeof rootRoute
    }
    '/legal/subprocessors': {
      id: '/legal/subprocessors'
      path: '/legal/subprocessors'
      fullPath: '/legal/subprocessors'
      preLoaderRoute: typeof LegalSubprocessorsImport
      parentRoute: typeof rootRoute
    }
    '/legal/security': {
      id: '/legal/security'
      path: '/legal/security'
      fullPath: '/legal/security'
      preLoaderRoute: typeof LegalSecurityImport
      parentRoute: typeof rootRoute
    }
    '/legal/dpa': {
      id: '/legal/dpa'
      path: '/legal/dpa'
      fullPath: '/legal/dpa'
      preLoaderRoute: typeof LegalDpaImport
      parentRoute: typeof rootRoute
    }
    '/compliance': {
      id: '/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof ComplianceRouteImport
      parentRoute: typeof rootRoute
    }
    '/compliance/fica': {
      id: '/compliance/fica'
      path: '/fica'
      fullPath: '/compliance/fica'
      preLoaderRoute: typeof ComplianceFicaImport
      parentRoute: typeof ComplianceRouteImport
    }
    '/compliance/popia': {
      id: '/compliance/popia'
      path: '/popia'
      fullPath: '/compliance/popia'
      preLoaderRoute: typeof CompliancePopiaImport
      parentRoute: typeof ComplianceRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRoute
    }
    '/audit/': {
      id: '/audit/'
      path: '/'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuditIndexImport
      parentRoute: typeof AuditRouteImport
    }
    '/audit/$trustId': {
      id: '/audit/$trustId'
      path: '/$trustId'
      fullPath: '/audit/$trustId'
      preLoaderRoute: typeof AuditTrustIdImport
      parentRoute: typeof AuditRouteImport
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppRouteImport
    }
    '/app/structure': {
      id: '/app/structure'
      path: '/structure'
      fullPath: '/app/structure'
      preLoaderRoute: typeof AppStructureImport
      parentRoute: typeof AppRouteImport
    }
    '/app/inbox': {
      id: '/app/inbox'
      path: '/inbox'
      fullPath: '/app/inbox'
      preLoaderRoute: typeof AppInboxImport
      parentRoute: typeof AppRouteImport
    }
    '/app/security': {
      id: '/app/security'
      path: '/security'
      fullPath: '/app/security'
      preLoaderRoute: typeof AppSecurityImport
      parentRoute: typeof AppRouteImport
    }
    '/app/firm-access': {
      id: '/app/firm-access'
      path: '/firm-access'
      fullPath: '/app/firm-access'
      preLoaderRoute: typeof AppFirmAccessImport
      parentRoute: typeof AppRouteImport
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileImport
      parentRoute: typeof AppRouteImport
    }
    '/app/privacy': {
      id: '/app/privacy'
      path: '/privacy'
      fullPath: '/app/privacy'
      preLoaderRoute: typeof AppPrivacyImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/': {
      id: '/app/trusts/'
      path: '/trusts'
      fullPath: '/app/trusts'
      preLoaderRoute: typeof AppTrustsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/': {
      id: '/app/trusts/$id/'
      path: '/trusts/$id'
      fullPath: '/app/trusts/$id'
      preLoaderRoute: typeof AppTrustsIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/distributions': {
      id: '/app/trusts/$id/distributions'
      path: '/trusts/$id/distributions'
      fullPath: '/app/trusts/$id/distributions'
      preLoaderRoute: typeof AppTrustsIdDistributionsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/tax': {
      id: '/app/trusts/$id/tax'
      path: '/trusts/$id/tax'
      fullPath: '/app/trusts/$id/tax'
      preLoaderRoute: typeof AppTrustsIdTaxImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/audit': {
      id: '/app/trusts/$id/audit'
      path: '/trusts/$id/audit'
      fullPath: '/app/trusts/$id/audit'
      preLoaderRoute: typeof AppTrustsIdAuditImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/documents': {
      id: '/app/trusts/$id/documents'
      path: '/trusts/$id/documents'
      fullPath: '/app/trusts/$id/documents'
      preLoaderRoute: typeof AppTrustsIdDocumentsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/portfolios': {
      id: '/app/trusts/$id/portfolios'
      path: '/trusts/$id/portfolios'
      fullPath: '/app/trusts/$id/portfolios'
      preLoaderRoute: typeof AppTrustsIdPortfoliosImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/properties': {
      id: '/app/trusts/$id/properties'
      path: '/trusts/$id/properties'
      fullPath: '/app/trusts/$id/properties'
      preLoaderRoute: typeof AppTrustsIdPropertiesImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/companies': {
      id: '/app/trusts/$id/companies'
      path: '/trusts/$id/companies'
      fullPath: '/app/trusts/$id/companies'
      preLoaderRoute: typeof AppTrustsIdCompaniesImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/assets': {
      id: '/app/trusts/$id/assets'
      path: '/trusts/$id/assets'
      fullPath: '/app/trusts/$id/assets'
      preLoaderRoute: typeof AppTrustsIdAssetsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/companies/$companyId': {
      id: '/app/trusts/$id/companies/$companyId'
      path: '/trusts/$id/companies/$companyId'
      fullPath: '/app/trusts/$id/companies/$companyId'
      preLoaderRoute: typeof AppTrustsIdCompaniesCompanyIdImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/meetings': {
      id: '/app/trusts/$id/meetings'
      path: '/trusts/$id/meetings'
      fullPath: '/app/trusts/$id/meetings'
      preLoaderRoute: typeof AppTrustsIdMeetingsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/meetings/new': {
      id: '/app/trusts/$id/meetings/new'
      path: '/trusts/$id/meetings/new'
      fullPath: '/app/trusts/$id/meetings/new'
      preLoaderRoute: typeof AppTrustsIdMeetingsNewImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/loa-low': {
      id: '/app/trusts/$id/loa-low'
      path: '/trusts/$id/loa-low'
      fullPath: '/app/trusts/$id/loa-low'
      preLoaderRoute: typeof AppTrustsIdLoaLowImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/risk-rating': {
      id: '/app/trusts/$id/risk-rating'
      path: '/trusts/$id/risk-rating'
      fullPath: '/app/trusts/$id/risk-rating'
      preLoaderRoute: typeof AppTrustsIdRiskRatingImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/settings': {
      id: '/app/trusts/$id/settings'
      path: '/trusts/$id/settings'
      fullPath: '/app/trusts/$id/settings'
      preLoaderRoute: typeof AppTrustsIdSettingsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/people/': {
      id: '/app/trusts/$id/people/'
      path: '/trusts/$id/people'
      fullPath: '/app/trusts/$id/people'
      preLoaderRoute: typeof AppTrustsIdPeopleIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/beneficiaries/': {
      id: '/app/trusts/$id/beneficiaries/'
      path: '/trusts/$id/beneficiaries'
      fullPath: '/app/trusts/$id/beneficiaries'
      preLoaderRoute: typeof AppTrustsIdBeneficiariesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/beneficial-ownership': {
      id: '/app/trusts/$id/beneficial-ownership'
      path: '/trusts/$id/beneficial-ownership'
      fullPath: '/app/trusts/$id/beneficial-ownership'
      preLoaderRoute: typeof AppTrustsIdBeneficiaryOwnershipImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/resolutions/': {
      id: '/app/trusts/$id/resolutions/'
      path: '/trusts/$id/resolutions'
      fullPath: '/app/trusts/$id/resolutions'
      preLoaderRoute: typeof AppTrustsIdResolutionsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/resolutions/$rid/sign': {
      id: '/app/trusts/$id/resolutions/$rid/sign'
      path: '/trusts/$id/resolutions/$rid/sign'
      fullPath: '/app/trusts/$id/resolutions/$rid/sign'
      preLoaderRoute: typeof AppTrustsIdResolutionsRidSignImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/resolutions/$rid/': {
      id: '/app/trusts/$id/resolutions/$rid/'
      path: '/trusts/$id/resolutions/$rid'
      fullPath: '/app/trusts/$id/resolutions/$rid'
      preLoaderRoute: typeof AppTrustsIdResolutionsRidIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trusts/$id/document-review/$jobId': {
      id: '/app/trusts/$id/document-review/$jobId'
      path: '/trusts/$id/document-review/$jobId'
      fullPath: '/app/trusts/$id/document-review/$jobId'
      preLoaderRoute: typeof AppTrustsIdDocumentReviewJobIdImport
      parentRoute: typeof AppRouteImport
    }
    '/app/trust': {
      id: '/app/trust'
      path: '/trust'
      fullPath: '/app/trust'
      preLoaderRoute: typeof AppTrustImport
      parentRoute: typeof AppRouteImport
    }
    '/app/resolutions/': {
      id: '/app/resolutions/'
      path: '/resolutions'
      fullPath: '/app/resolutions'
      preLoaderRoute: typeof AppResolutionsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/resolutions/$id/sign': {
      id: '/app/resolutions/$id/sign'
      path: '/resolutions/$id/sign'
      fullPath: '/app/resolutions/$id/sign'
      preLoaderRoute: typeof AppResolutionsIdSignImport
      parentRoute: typeof AppRouteImport
    }
    '/app/documents': {
      id: '/app/documents'
      path: '/documents'
      fullPath: '/app/documents'
      preLoaderRoute: typeof AppDocumentsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/beneficiaries/': {
      id: '/app/beneficiaries/'
      path: '/beneficiaries'
      fullPath: '/app/beneficiaries'
      preLoaderRoute: typeof AppBeneficiariesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/beneficiaries/ownership': {
      id: '/app/beneficiaries/ownership'
      path: '/beneficiaries/ownership'
      fullPath: '/app/beneficiaries/ownership'
      preLoaderRoute: typeof AppBeneficiariesOwnershipImport
      parentRoute: typeof AppRouteImport
    }
    '/app/distributions': {
      id: '/app/distributions'
      path: '/distributions'
      fullPath: '/app/distributions'
      preLoaderRoute: typeof AppDistributionsImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tax': {
      id: '/app/tax'
      path: '/tax'
      fullPath: '/app/tax'
      preLoaderRoute: typeof AppTaxImport
      parentRoute: typeof AppRouteImport
    }
    '/app/audit': {
      id: '/app/audit'
      path: '/audit'
      fullPath: '/app/audit'
      preLoaderRoute: typeof AppAuditImport
      parentRoute: typeof AppRouteImport
    }
    '/app/messages': {
      id: '/app/messages'
      path: '/messages'
      fullPath: '/app/messages'
      preLoaderRoute: typeof AppMessagesImport
      parentRoute: typeof AppRouteImport
    }
    '/superadmin/': {
      id: '/superadmin/'
      path: '/'
      fullPath: '/superadmin/'
      preLoaderRoute: typeof SuperAdminIndexImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/tiers': {
      id: '/superadmin/tiers'
      path: '/tiers'
      fullPath: '/superadmin/tiers'
      preLoaderRoute: typeof SuperAdminTiersImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/recovery': {
      id: '/superadmin/recovery'
      path: '/recovery'
      fullPath: '/superadmin/recovery'
      preLoaderRoute: typeof SuperAdminRecoveryImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/audit': {
      id: '/superadmin/audit'
      path: '/audit'
      fullPath: '/superadmin/audit'
      preLoaderRoute: typeof SuperAdminAuditImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/subprocessors': {
      id: '/superadmin/subprocessors'
      path: '/subprocessors'
      fullPath: '/superadmin/subprocessors'
      preLoaderRoute: typeof SuperAdminSubprocessorsImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/settings': {
      id: '/superadmin/settings'
      path: '/settings'
      fullPath: '/superadmin/settings'
      preLoaderRoute: typeof SuperAdminSettingsImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/tenants/': {
      id: '/superadmin/tenants/'
      path: '/tenants'
      fullPath: '/superadmin/tenants'
      preLoaderRoute: typeof SuperAdminTenantsIndexImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/tenants/$id': {
      id: '/superadmin/tenants/$id'
      path: '/tenants/$id'
      fullPath: '/superadmin/tenants/$id'
      preLoaderRoute: typeof SuperAdminTenantsIdImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/client-book': {
      id: '/admin/client-book'
      path: '/client-book'
      fullPath: '/admin/client-book'
      preLoaderRoute: typeof AdminClientBookImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/branding': {
      id: '/admin/branding'
      path: '/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AdminBrandingImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/clients/': {
      id: '/admin/clients/'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/clients/$id': {
      id: '/admin/clients/$id'
      path: '/clients/$id'
      fullPath: '/admin/clients/$id'
      preLoaderRoute: typeof AdminClientsIdImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/team': {
      id: '/admin/team'
      path: '/team'
      fullPath: '/admin/team'
      preLoaderRoute: typeof AdminTeamImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/partner-earnings': {
      id: '/admin/partner-earnings'
      path: '/partner-earnings'
      fullPath: '/admin/partner-earnings'
      preLoaderRoute: typeof AdminPartnerEarningsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/integrations': {
      id: '/admin/integrations'
      path: '/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/entity-graph': {
      id: '/admin/entity-graph'
      path: '/entity-graph'
      fullPath: '/admin/entity-graph'
      preLoaderRoute: typeof AdminEntityGraphImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/dsar': {
      id: '/admin/dsar'
      path: '/dsar'
      fullPath: '/admin/dsar'
      preLoaderRoute: typeof AdminDsarImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/compliance-reports': {
      id: '/admin/compliance-reports'
      path: '/compliance-reports'
      fullPath: '/admin/compliance-reports'
      preLoaderRoute: typeof AdminComplianceReportsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/recovery-requests': {
      id: '/admin/recovery-requests'
      path: '/recovery-requests'
      fullPath: '/admin/recovery-requests'
      preLoaderRoute: typeof AdminRecoveryRequestsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/external-auditors': {
      id: '/admin/external-auditors'
      path: '/external-auditors'
      fullPath: '/admin/external-auditors'
      preLoaderRoute: typeof AdminExternalAuditorsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/master-lodgements': {
      id: '/admin/master-lodgements'
      path: '/master-lodgements'
      fullPath: '/admin/master-lodgements'
      preLoaderRoute: typeof AdminMasterLodgementsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/document-coverage': {
      id: '/admin/document-coverage'
      path: '/document-coverage'
      fullPath: '/admin/document-coverage'
      preLoaderRoute: typeof AdminDocumentCoverageImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/documents': {
      id: '/admin/documents'
      path: '/documents'
      fullPath: '/admin/documents'
      preLoaderRoute: typeof AdminDocumentsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/fic-reports': {
      id: '/admin/fic-reports'
      path: '/fic-reports'
      fullPath: '/admin/fic-reports'
      preLoaderRoute: typeof AdminFicReportsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/fic-reports/new': {
      id: '/admin/fic-reports/new'
      path: '/fic-reports/new'
      fullPath: '/admin/fic-reports/new'
      preLoaderRoute: typeof AdminFicReportsNewImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/fic-reports/$id': {
      id: '/admin/fic-reports/$id'
      path: '/fic-reports/$id'
      fullPath: '/admin/fic-reports/$id'
      preLoaderRoute: typeof AdminFicReportsIdImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/risk-review': {
      id: '/admin/risk-review'
      path: '/risk-review'
      fullPath: '/admin/risk-review'
      preLoaderRoute: typeof AdminRiskReviewImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/edd': {
      id: '/admin/edd'
      path: '/edd'
      fullPath: '/admin/edd'
      preLoaderRoute: typeof AdminEddImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/edd/$id': {
      id: '/admin/edd/$id'
      path: '/edd/$id'
      fullPath: '/admin/edd/$id'
      preLoaderRoute: typeof AdminEddIdImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/aes-sync-log': {
      id: '/admin/aes-sync-log'
      path: '/aes-sync-log'
      fullPath: '/admin/aes-sync-log'
      preLoaderRoute: typeof AdminAesSyncLogImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/legal-holds': {
      id: '/admin/legal-holds'
      path: '/legal-holds'
      fullPath: '/admin/legal-holds'
      preLoaderRoute: typeof AdminLegalHoldsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/branding/custom-domain': {
      id: '/admin/branding/custom-domain'
      path: '/branding/custom-domain'
      fullPath: '/admin/branding/custom-domain'
      preLoaderRoute: typeof AdminBrandingCustomDomainImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/queue': {
      id: '/admin/queue'
      path: '/queue'
      fullPath: '/admin/queue'
      preLoaderRoute: typeof AdminQueueImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/trusts': {
      id: '/admin/trusts'
      path: '/trusts'
      fullPath: '/admin/trusts'
      preLoaderRoute: typeof AdminTrustsImport
      parentRoute: typeof AdminRouteImport
    }
    '/admin/fica': {
      id: '/admin/fica'
      path: '/fica'
      fullPath: '/admin/fica'
      preLoaderRoute: typeof AdminFicaImport
      parentRoute: typeof AdminRouteImport
    }
    '/superadmin/sentinel-rules': {
      id: '/superadmin/sentinel-rules'
      path: '/sentinel-rules'
      fullPath: '/superadmin/sentinel-rules'
      preLoaderRoute: typeof SuperAdminSentinelRulesImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/health': {
      id: '/superadmin/health'
      path: '/health'
      fullPath: '/superadmin/health'
      preLoaderRoute: typeof SuperAdminHealthImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/pricing': {
      id: '/superadmin/pricing'
      path: '/pricing'
      fullPath: '/superadmin/pricing'
      preLoaderRoute: typeof SuperAdminPricingImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/superadmin/features': {
      id: '/superadmin/features'
      path: '/features'
      fullPath: '/superadmin/features'
      preLoaderRoute: typeof SuperAdminFeaturesImport
      parentRoute: typeof SuperAdminRouteImport
    }
    '/onboarding/firm': {
      id: '/onboarding/firm'
      path: '/onboarding/firm'
      fullPath: '/onboarding/firm'
      preLoaderRoute: typeof OnboardingFirmImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/individual': {
      id: '/onboarding/individual'
      path: '/onboarding/individual'
      fullPath: '/onboarding/individual'
      preLoaderRoute: typeof OnboardingIndividualImport
      parentRoute: typeof rootRoute
    }
    '/onboarding/invited': {
      id: '/onboarding/invited'
      path: '/onboarding/invited'
      fullPath: '/onboarding/invited'
      preLoaderRoute: typeof OnboardingInvitedImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/pricing': typeof PricingRoute
  '/contact': typeof ContactRoute
  '/help': typeof HelpRoute
  '/product': typeof ProductRoute
  '/security': typeof SecurityRoute
  '/customers': typeof CustomersRoute
  '/status': typeof StatusRoute
  '/changelog': typeof ChangelogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/onboarding-a-trust': typeof DocsOnboardingTrustRoute
  '/docs/signing-flow': typeof DocsSigningFlowRoute
  '/brandbook': typeof BrandbookRoute
  '/firms': typeof FirmsRoute
  '/app': typeof AppRoute
  '/superadmin': typeof SuperAdminRoute
  '/admin': typeof AdminRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/workspace-invite': typeof AuthWorkspaceInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/recovery': typeof AuthRecoveryRoute
  '/auth/recovery/lost-both': typeof AuthRecoveryLostBothRoute
  '/auth/recovery/status': typeof AuthRecoveryStatusRoute
  '/sign/external/$token': typeof SignExternalTokenRoute
  '/sign/external/return': typeof SignExternalReturnRoute
  '/auth/mfa-enroll': typeof AuthMfaEnrollRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/refresh-step-up': typeof AuthRefreshStepUpRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/terms': typeof LegalTermsRoute
  '/partner/finder-dashboard': typeof PartnerFinderDashboardRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/trust-centre': typeof LegalTrustCentreRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/compliance': typeof ComplianceRoute
  '/compliance/fica': typeof ComplianceFicaRoute
  '/compliance/popia': typeof CompliancePopiaRoute
  '/audit': typeof AuditRoute
  '/audit/': typeof AuditIndexRoute
  '/audit/$trustId': typeof AuditTrustIdRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/structure': typeof AppStructureRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/security': typeof AppSecurityRoute
  '/app/firm-access': typeof AppFirmAccessRoute
  '/app/profile': typeof AppProfileRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/trusts': typeof AppTrustsIndexRoute
  '/app/trusts/$id': typeof AppTrustsIdIndexRoute
  '/app/trusts/$id/distributions': typeof AppTrustsIdDistributionsRoute
  '/app/trusts/$id/tax': typeof AppTrustsIdTaxRoute
  '/app/trusts/$id/audit': typeof AppTrustsIdAuditRoute
  '/app/trusts/$id/documents': typeof AppTrustsIdDocumentsRoute
  '/app/trusts/$id/portfolios': typeof AppTrustsIdPortfoliosRoute
  '/app/trusts/$id/properties': typeof AppTrustsIdPropertiesRoute
  '/app/trusts/$id/companies': typeof AppTrustsIdCompaniesRoute
  '/app/trusts/$id/assets': typeof AppTrustsIdAssetsRoute
  '/app/trusts/$id/companies/$companyId': typeof AppTrustsIdCompaniesCompanyIdRoute
  '/app/trusts/$id/meetings': typeof AppTrustsIdMeetingsRoute
  '/app/trusts/$id/meetings/new': typeof AppTrustsIdMeetingsNewRoute
  '/app/trusts/$id/loa-low': typeof AppTrustsIdLoaLowRoute
  '/app/trusts/$id/risk-rating': typeof AppTrustsIdRiskRatingRoute
  '/app/trusts/$id/settings': typeof AppTrustsIdSettingsRoute
  '/app/trusts/$id/people': typeof AppTrustsIdPeopleIndexRoute
  '/app/trusts/$id/beneficiaries': typeof AppTrustsIdBeneficiariesIndexRoute
  '/app/trusts/$id/beneficial-ownership': typeof AppTrustsIdBeneficiaryOwnershipRoute
  '/app/trusts/$id/resolutions': typeof AppTrustsIdResolutionsIndexRoute
  '/app/trusts/$id/resolutions/$rid/sign': typeof AppTrustsIdResolutionsRidSignRoute
  '/app/trusts/$id/resolutions/$rid': typeof AppTrustsIdResolutionsRidIndexRoute
  '/app/trusts/$id/document-review/$jobId': typeof AppTrustsIdDocumentReviewJobIdRoute
  '/app/trust': typeof AppTrustRoute
  '/app/resolutions': typeof AppResolutionsIndexRoute
  '/app/resolutions/$id/sign': typeof AppResolutionsIdSignRoute
  '/app/documents': typeof AppDocumentsRoute
  '/app/beneficiaries': typeof AppBeneficiariesIndexRoute
  '/app/beneficiaries/ownership': typeof AppBeneficiariesOwnershipRoute
  '/app/distributions': typeof AppDistributionsRoute
  '/app/tax': typeof AppTaxRoute
  '/app/audit': typeof AppAuditRoute
  '/app/messages': typeof AppMessagesRoute
  '/superadmin/': typeof SuperAdminIndexRoute
  '/superadmin/tiers': typeof SuperAdminTiersRoute
  '/superadmin/recovery': typeof SuperAdminRecoveryRoute
  '/superadmin/audit': typeof SuperAdminAuditRoute
  '/superadmin/subprocessors': typeof SuperAdminSubprocessorsRoute
  '/superadmin/settings': typeof SuperAdminSettingsRoute
  '/superadmin/tenants': typeof SuperAdminTenantsIndexRoute
  '/superadmin/tenants/$id': typeof SuperAdminTenantsIdRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/client-book': typeof AdminClientBookRoute
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/partner-earnings': typeof AdminPartnerEarningsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/entity-graph': typeof AdminEntityGraphRoute
  '/admin/dsar': typeof AdminDsarRoute
  '/admin/compliance-reports': typeof AdminComplianceReportsRoute
  '/admin/recovery-requests': typeof AdminRecoveryRequestsRoute
  '/admin/external-auditors': typeof AdminExternalAuditorsRoute
  '/admin/master-lodgements': typeof AdminMasterLodgementsRoute
  '/admin/document-coverage': typeof AdminDocumentCoverageRoute
  '/admin/documents': typeof AdminDocumentsRoute
  '/admin/fic-reports': typeof AdminFicReportsRoute
  '/admin/fic-reports/new': typeof AdminFicReportsNewRoute
  '/admin/fic-reports/$id': typeof AdminFicReportsIdRoute
  '/admin/risk-review': typeof AdminRiskReviewRoute
  '/admin/edd': typeof AdminEddRoute
  '/admin/edd/$id': typeof AdminEddIdRoute
  '/admin/aes-sync-log': typeof AdminAesSyncLogRoute
  '/admin/legal-holds': typeof AdminLegalHoldsRoute
  '/admin/branding/custom-domain': typeof AdminBrandingCustomDomainRoute
  '/admin/queue': typeof AdminQueueRoute
  '/admin/trusts': typeof AdminTrustsRoute
  '/admin/fica': typeof AdminFicaRoute
  '/superadmin/sentinel-rules': typeof SuperAdminSentinelRulesRoute
  '/superadmin/health': typeof SuperAdminHealthRoute
  '/superadmin/pricing': typeof SuperAdminPricingRoute
  '/superadmin/features': typeof SuperAdminFeaturesRoute
  '/onboarding/firm': typeof OnboardingFirmRoute
  '/onboarding/individual': typeof OnboardingIndividualRoute
  '/onboarding/invited': typeof OnboardingInvitedRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/pricing': typeof PricingRoute
  '/contact': typeof ContactRoute
  '/help': typeof HelpRoute
  '/product': typeof ProductRoute
  '/security': typeof SecurityRoute
  '/customers': typeof CustomersRoute
  '/status': typeof StatusRoute
  '/changelog': typeof ChangelogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/onboarding-a-trust': typeof DocsOnboardingTrustRoute
  '/docs/signing-flow': typeof DocsSigningFlowRoute
  '/brandbook': typeof BrandbookRoute
  '/firms': typeof FirmsRoute
  '/app': typeof AppRoute
  '/superadmin': typeof SuperAdminRoute
  '/admin': typeof AdminRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/workspace-invite': typeof AuthWorkspaceInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/recovery': typeof AuthRecoveryRoute
  '/auth/recovery/lost-both': typeof AuthRecoveryLostBothRoute
  '/auth/recovery/status': typeof AuthRecoveryStatusRoute
  '/sign/external/$token': typeof SignExternalTokenRoute
  '/sign/external/return': typeof SignExternalReturnRoute
  '/auth/mfa-enroll': typeof AuthMfaEnrollRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/refresh-step-up': typeof AuthRefreshStepUpRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/terms': typeof LegalTermsRoute
  '/partner/finder-dashboard': typeof PartnerFinderDashboardRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/trust-centre': typeof LegalTrustCentreRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/compliance': typeof ComplianceRoute
  '/compliance/fica': typeof ComplianceFicaRoute
  '/compliance/popia': typeof CompliancePopiaRoute
  '/audit': typeof AuditRoute
  '/audit/': typeof AuditIndexRoute
  '/audit/$trustId': typeof AuditTrustIdRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/structure': typeof AppStructureRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/security': typeof AppSecurityRoute
  '/app/firm-access': typeof AppFirmAccessRoute
  '/app/profile': typeof AppProfileRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/trusts': typeof AppTrustsIndexRoute
  '/app/trusts/$id': typeof AppTrustsIdIndexRoute
  '/app/trusts/$id/distributions': typeof AppTrustsIdDistributionsRoute
  '/app/trusts/$id/tax': typeof AppTrustsIdTaxRoute
  '/app/trusts/$id/audit': typeof AppTrustsIdAuditRoute
  '/app/trusts/$id/documents': typeof AppTrustsIdDocumentsRoute
  '/app/trusts/$id/portfolios': typeof AppTrustsIdPortfoliosRoute
  '/app/trusts/$id/properties': typeof AppTrustsIdPropertiesRoute
  '/app/trusts/$id/companies': typeof AppTrustsIdCompaniesRoute
  '/app/trusts/$id/assets': typeof AppTrustsIdAssetsRoute
  '/app/trusts/$id/companies/$companyId': typeof AppTrustsIdCompaniesCompanyIdRoute
  '/app/trusts/$id/meetings': typeof AppTrustsIdMeetingsRoute
  '/app/trusts/$id/meetings/new': typeof AppTrustsIdMeetingsNewRoute
  '/app/trusts/$id/loa-low': typeof AppTrustsIdLoaLowRoute
  '/app/trusts/$id/risk-rating': typeof AppTrustsIdRiskRatingRoute
  '/app/trusts/$id/settings': typeof AppTrustsIdSettingsRoute
  '/app/trusts/$id/people': typeof AppTrustsIdPeopleIndexRoute
  '/app/trusts/$id/beneficiaries': typeof AppTrustsIdBeneficiariesIndexRoute
  '/app/trusts/$id/beneficial-ownership': typeof AppTrustsIdBeneficiaryOwnershipRoute
  '/app/trusts/$id/resolutions': typeof AppTrustsIdResolutionsIndexRoute
  '/app/trusts/$id/resolutions/$rid/sign': typeof AppTrustsIdResolutionsRidSignRoute
  '/app/trusts/$id/resolutions/$rid': typeof AppTrustsIdResolutionsRidIndexRoute
  '/app/trusts/$id/document-review/$jobId': typeof AppTrustsIdDocumentReviewJobIdRoute
  '/app/trust': typeof AppTrustRoute
  '/app/resolutions': typeof AppResolutionsIndexRoute
  '/app/resolutions/$id/sign': typeof AppResolutionsIdSignRoute
  '/app/documents': typeof AppDocumentsRoute
  '/app/beneficiaries': typeof AppBeneficiariesIndexRoute
  '/app/beneficiaries/ownership': typeof AppBeneficiariesOwnershipRoute
  '/app/distributions': typeof AppDistributionsRoute
  '/app/tax': typeof AppTaxRoute
  '/app/audit': typeof AppAuditRoute
  '/app/messages': typeof AppMessagesRoute
  '/superadmin/': typeof SuperAdminIndexRoute
  '/superadmin/tiers': typeof SuperAdminTiersRoute
  '/superadmin/recovery': typeof SuperAdminRecoveryRoute
  '/superadmin/audit': typeof SuperAdminAuditRoute
  '/superadmin/subprocessors': typeof SuperAdminSubprocessorsRoute
  '/superadmin/settings': typeof SuperAdminSettingsRoute
  '/superadmin/tenants': typeof SuperAdminTenantsIndexRoute
  '/superadmin/tenants/$id': typeof SuperAdminTenantsIdRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/client-book': typeof AdminClientBookRoute
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/clients': typeof AdminClientsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/partner-earnings': typeof AdminPartnerEarningsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/entity-graph': typeof AdminEntityGraphRoute
  '/admin/dsar': typeof AdminDsarRoute
  '/admin/compliance-reports': typeof AdminComplianceReportsRoute
  '/admin/recovery-requests': typeof AdminRecoveryRequestsRoute
  '/admin/external-auditors': typeof AdminExternalAuditorsRoute
  '/admin/master-lodgements': typeof AdminMasterLodgementsRoute
  '/admin/document-coverage': typeof AdminDocumentCoverageRoute
  '/admin/documents': typeof AdminDocumentsRoute
  '/admin/fic-reports': typeof AdminFicReportsRoute
  '/admin/fic-reports/new': typeof AdminFicReportsNewRoute
  '/admin/fic-reports/$id': typeof AdminFicReportsIdRoute
  '/admin/risk-review': typeof AdminRiskReviewRoute
  '/admin/edd': typeof AdminEddRoute
  '/admin/edd/$id': typeof AdminEddIdRoute
  '/admin/aes-sync-log': typeof AdminAesSyncLogRoute
  '/admin/legal-holds': typeof AdminLegalHoldsRoute
  '/admin/branding/custom-domain': typeof AdminBrandingCustomDomainRoute
  '/admin/queue': typeof AdminQueueRoute
  '/admin/trusts': typeof AdminTrustsRoute
  '/admin/fica': typeof AdminFicaRoute
  '/superadmin/sentinel-rules': typeof SuperAdminSentinelRulesRoute
  '/superadmin/health': typeof SuperAdminHealthRoute
  '/superadmin/pricing': typeof SuperAdminPricingRoute
  '/superadmin/features': typeof SuperAdminFeaturesRoute
  '/onboarding/firm': typeof OnboardingFirmRoute
  '/onboarding/individual': typeof OnboardingIndividualRoute
  '/onboarding/invited': typeof OnboardingInvitedRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/pricing': typeof PricingRoute
  '/contact': typeof ContactRoute
  '/help': typeof HelpRoute
  '/product': typeof ProductRoute
  '/security': typeof SecurityRoute
  '/customers': typeof CustomersRoute
  '/status': typeof StatusRoute
  '/changelog': typeof ChangelogRoute
  '/careers': typeof CareersRoute
  '/docs': typeof DocsRoute
  '/docs/getting-started': typeof DocsGettingStartedRoute
  '/docs/onboarding-a-trust': typeof DocsOnboardingTrustRoute
  '/docs/signing-flow': typeof DocsSigningFlowRoute
  '/brandbook': typeof BrandbookRoute
  '/firms': typeof FirmsRoute
  '/app': typeof AppRoute
  '/superadmin': typeof SuperAdminRoute
  '/admin': typeof AdminRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/workspace-invite': typeof AuthWorkspaceInviteRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/recovery': typeof AuthRecoveryRoute
  '/auth/recovery/lost-both': typeof AuthRecoveryLostBothRoute
  '/auth/recovery/status': typeof AuthRecoveryStatusRoute
  '/sign/external/$token': typeof SignExternalTokenRoute
  '/sign/external/return': typeof SignExternalReturnRoute
  '/auth/mfa-enroll': typeof AuthMfaEnrollRoute
  '/auth/mfa-verify': typeof AuthMfaVerifyRoute
  '/auth/refresh-step-up': typeof AuthRefreshStepUpRoute
  '/legal/privacy': typeof LegalPrivacyRoute
  '/legal/paia': typeof LegalPaiaRoute
  '/legal/terms': typeof LegalTermsRoute
  '/partner/finder-dashboard': typeof PartnerFinderDashboardRoute
  '/legal/cookies': typeof LegalCookiesRoute
  '/legal/trust-centre': typeof LegalTrustCentreRoute
  '/legal/subprocessors': typeof LegalSubprocessorsRoute
  '/legal/security': typeof LegalSecurityRoute
  '/legal/dpa': typeof LegalDpaRoute
  '/compliance': typeof ComplianceRoute
  '/compliance/fica': typeof ComplianceFicaRoute
  '/compliance/popia': typeof CompliancePopiaRoute
  '/audit': typeof AuditRoute
  '/audit/': typeof AuditIndexRoute
  '/audit/$trustId': typeof AuditTrustIdRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/structure': typeof AppStructureRoute
  '/app/inbox': typeof AppInboxRoute
  '/app/security': typeof AppSecurityRoute
  '/app/firm-access': typeof AppFirmAccessRoute
  '/app/profile': typeof AppProfileRoute
  '/app/privacy': typeof AppPrivacyRoute
  '/app/trusts/': typeof AppTrustsIndexRoute
  '/app/trusts/$id/': typeof AppTrustsIdIndexRoute
  '/app/trusts/$id/distributions': typeof AppTrustsIdDistributionsRoute
  '/app/trusts/$id/tax': typeof AppTrustsIdTaxRoute
  '/app/trusts/$id/audit': typeof AppTrustsIdAuditRoute
  '/app/trusts/$id/documents': typeof AppTrustsIdDocumentsRoute
  '/app/trusts/$id/portfolios': typeof AppTrustsIdPortfoliosRoute
  '/app/trusts/$id/properties': typeof AppTrustsIdPropertiesRoute
  '/app/trusts/$id/companies': typeof AppTrustsIdCompaniesRoute
  '/app/trusts/$id/assets': typeof AppTrustsIdAssetsRoute
  '/app/trusts/$id/companies/$companyId': typeof AppTrustsIdCompaniesCompanyIdRoute
  '/app/trusts/$id/meetings': typeof AppTrustsIdMeetingsRoute
  '/app/trusts/$id/meetings/new': typeof AppTrustsIdMeetingsNewRoute
  '/app/trusts/$id/loa-low': typeof AppTrustsIdLoaLowRoute
  '/app/trusts/$id/risk-rating': typeof AppTrustsIdRiskRatingRoute
  '/app/trusts/$id/settings': typeof AppTrustsIdSettingsRoute
  '/app/trusts/$id/people/': typeof AppTrustsIdPeopleIndexRoute
  '/app/trusts/$id/beneficiaries/': typeof AppTrustsIdBeneficiariesIndexRoute
  '/app/trusts/$id/beneficial-ownership': typeof AppTrustsIdBeneficiaryOwnershipRoute
  '/app/trusts/$id/resolutions/': typeof AppTrustsIdResolutionsIndexRoute
  '/app/trusts/$id/resolutions/$rid/sign': typeof AppTrustsIdResolutionsRidSignRoute
  '/app/trusts/$id/resolutions/$rid/': typeof AppTrustsIdResolutionsRidIndexRoute
  '/app/trusts/$id/document-review/$jobId': typeof AppTrustsIdDocumentReviewJobIdRoute
  '/app/trust': typeof AppTrustRoute
  '/app/resolutions/': typeof AppResolutionsIndexRoute
  '/app/resolutions/$id/sign': typeof AppResolutionsIdSignRoute
  '/app/documents': typeof AppDocumentsRoute
  '/app/beneficiaries/': typeof AppBeneficiariesIndexRoute
  '/app/beneficiaries/ownership': typeof AppBeneficiariesOwnershipRoute
  '/app/distributions': typeof AppDistributionsRoute
  '/app/tax': typeof AppTaxRoute
  '/app/audit': typeof AppAuditRoute
  '/app/messages': typeof AppMessagesRoute
  '/superadmin/': typeof SuperAdminIndexRoute
  '/superadmin/tiers': typeof SuperAdminTiersRoute
  '/superadmin/recovery': typeof SuperAdminRecoveryRoute
  '/superadmin/audit': typeof SuperAdminAuditRoute
  '/superadmin/subprocessors': typeof SuperAdminSubprocessorsRoute
  '/superadmin/settings': typeof SuperAdminSettingsRoute
  '/superadmin/tenants/': typeof SuperAdminTenantsIndexRoute
  '/superadmin/tenants/$id': typeof SuperAdminTenantsIdRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/client-book': typeof AdminClientBookRoute
  '/admin/branding': typeof AdminBrandingRoute
  '/admin/clients/': typeof AdminClientsIndexRoute
  '/admin/clients/$id': typeof AdminClientsIdRoute
  '/admin/team': typeof AdminTeamRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/partner-earnings': typeof AdminPartnerEarningsRoute
  '/admin/integrations': typeof AdminIntegrationsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/entity-graph': typeof AdminEntityGraphRoute
  '/admin/dsar': typeof AdminDsarRoute
  '/admin/compliance-reports': typeof AdminComplianceReportsRoute
  '/admin/recovery-requests': typeof AdminRecoveryRequestsRoute
  '/admin/external-auditors': typeof AdminExternalAuditorsRoute
  '/admin/master-lodgements': typeof AdminMasterLodgementsRoute
  '/admin/document-coverage': typeof AdminDocumentCoverageRoute
  '/admin/documents': typeof AdminDocumentsRoute
  '/admin/fic-reports': typeof AdminFicReportsRoute
  '/admin/fic-reports/new': typeof AdminFicReportsNewRoute
  '/admin/fic-reports/$id': typeof AdminFicReportsIdRoute
  '/admin/risk-review': typeof AdminRiskReviewRoute
  '/admin/edd': typeof AdminEddRoute
  '/admin/edd/$id': typeof AdminEddIdRoute
  '/admin/aes-sync-log': typeof AdminAesSyncLogRoute
  '/admin/legal-holds': typeof AdminLegalHoldsRoute
  '/admin/branding/custom-domain': typeof AdminBrandingCustomDomainRoute
  '/admin/queue': typeof AdminQueueRoute
  '/admin/trusts': typeof AdminTrustsRoute
  '/admin/fica': typeof AdminFicaRoute
  '/superadmin/sentinel-rules': typeof SuperAdminSentinelRulesRoute
  '/superadmin/health': typeof SuperAdminHealthRoute
  '/superadmin/pricing': typeof SuperAdminPricingRoute
  '/superadmin/features': typeof SuperAdminFeaturesRoute
  '/onboarding/firm': typeof OnboardingFirmRoute
  '/onboarding/individual': typeof OnboardingIndividualRoute
  '/onboarding/invited': typeof OnboardingInvitedRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/pricing'
    | '/contact'
    | '/help'
    | '/product'
    | '/security'
    | '/customers'
    | '/status'
    | '/changelog'
    | '/careers'
    | '/docs'
    | '/docs/getting-started'
    | '/docs/onboarding-a-trust'
    | '/docs/signing-flow'
    | '/brandbook'
    | '/firms'
    | '/app'
    | '/superadmin'
    | '/admin'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/forgot'
    | '/auth/reset-password'
    | '/auth/check-email'
    | '/auth/workspace-invite'
    | '/auth/recovery'
    | '/auth/recovery/lost-both'
    | '/auth/recovery/status'
    | '/sign/external/$token'
    | '/sign/external/return'
    | '/auth/mfa-enroll'
    | '/auth/mfa-verify'
    | '/auth/refresh-step-up'
    | '/legal/privacy'
    | '/legal/paia'
    | '/legal/terms'
    | '/partner/finder-dashboard'
    | '/legal/cookies'
    | '/legal/trust-centre'
    | '/legal/subprocessors'
    | '/legal/security'
    | '/legal/dpa'
    | '/compliance'
    | '/compliance/fica'
    | '/compliance/popia'
    | '/audit'
    | '/audit/'
    | '/audit/$trustId'
    | '/app/dashboard'
    | '/app/structure'
    | '/app/inbox'
    | '/app/security'
    | '/app/firm-access'
    | '/app/profile'
    | '/app/privacy'
    | '/app/trusts'
    | '/app/trusts/$id'
    | '/app/trusts/$id/distributions'
    | '/app/trusts/$id/tax'
    | '/app/trusts/$id/audit'
    | '/app/trusts/$id/documents'
    | '/app/trusts/$id/portfolios'
    | '/app/trusts/$id/properties'
    | '/app/trusts/$id/companies'
    | '/app/trusts/$id/assets'
    | '/app/trusts/$id/companies/$companyId'
    | '/app/trusts/$id/meetings'
    | '/app/trusts/$id/meetings/new'
    | '/app/trusts/$id/loa-low'
    | '/app/trusts/$id/risk-rating'
    | '/app/trusts/$id/settings'
    | '/app/trusts/$id/people'
    | '/app/trusts/$id/beneficiaries'
    | '/app/trusts/$id/beneficial-ownership'
    | '/app/trusts/$id/resolutions'
    | '/app/trusts/$id/resolutions/$rid/sign'
    | '/app/trusts/$id/resolutions/$rid'
    | '/app/trusts/$id/document-review/$jobId'
    | '/app/trust'
    | '/app/resolutions'
    | '/app/resolutions/$id/sign'
    | '/app/documents'
    | '/app/beneficiaries'
    | '/app/beneficiaries/ownership'
    | '/app/distributions'
    | '/app/tax'
    | '/app/audit'
    | '/app/messages'
    | '/superadmin/'
    | '/superadmin/tiers'
    | '/superadmin/recovery'
    | '/superadmin/audit'
    | '/superadmin/subprocessors'
    | '/superadmin/settings'
    | '/superadmin/tenants'
    | '/superadmin/tenants/$id'
    | '/admin/dashboard'
    | '/admin/client-book'
    | '/admin/branding'
    | '/admin/clients'
    | '/admin/clients/$id'
    | '/admin/team'
    | '/admin/billing'
    | '/admin/partner-earnings'
    | '/admin/integrations'
    | '/admin/audit'
    | '/admin/entity-graph'
    | '/admin/dsar'
    | '/admin/compliance-reports'
    | '/admin/recovery-requests'
    | '/admin/external-auditors'
    | '/admin/master-lodgements'
    | '/admin/document-coverage'
    | '/admin/documents'
    | '/admin/fic-reports'
    | '/admin/fic-reports/new'
    | '/admin/fic-reports/$id'
    | '/admin/risk-review'
    | '/admin/edd'
    | '/admin/edd/$id'
    | '/admin/aes-sync-log'
    | '/admin/legal-holds'
    | '/admin/branding/custom-domain'
    | '/admin/queue'
    | '/admin/trusts'
    | '/admin/fica'
    | '/superadmin/sentinel-rules'
    | '/superadmin/health'
    | '/superadmin/pricing'
    | '/superadmin/features'
    | '/onboarding/firm'
    | '/onboarding/individual'
    | '/onboarding/invited'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/pricing'
    | '/contact'
    | '/help'
    | '/product'
    | '/security'
    | '/customers'
    | '/status'
    | '/changelog'
    | '/careers'
    | '/docs'
    | '/docs/getting-started'
    | '/docs/onboarding-a-trust'
    | '/docs/signing-flow'
    | '/brandbook'
    | '/firms'
    | '/app'
    | '/superadmin'
    | '/admin'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/forgot'
    | '/auth/reset-password'
    | '/auth/check-email'
    | '/auth/workspace-invite'
    | '/auth/recovery'
    | '/auth/recovery/lost-both'
    | '/auth/recovery/status'
    | '/sign/external/$token'
    | '/sign/external/return'
    | '/auth/mfa-enroll'
    | '/auth/mfa-verify'
    | '/auth/refresh-step-up'
    | '/legal/privacy'
    | '/legal/paia'
    | '/legal/terms'
    | '/partner/finder-dashboard'
    | '/legal/cookies'
    | '/legal/trust-centre'
    | '/legal/subprocessors'
    | '/legal/security'
    | '/legal/dpa'
    | '/compliance'
    | '/compliance/fica'
    | '/compliance/popia'
    | '/audit'
    | '/audit/'
    | '/audit/$trustId'
    | '/app/dashboard'
    | '/app/structure'
    | '/app/inbox'
    | '/app/security'
    | '/app/firm-access'
    | '/app/profile'
    | '/app/privacy'
    | '/app/trusts'
    | '/app/trusts/$id'
    | '/app/trusts/$id/distributions'
    | '/app/trusts/$id/tax'
    | '/app/trusts/$id/audit'
    | '/app/trusts/$id/documents'
    | '/app/trusts/$id/portfolios'
    | '/app/trusts/$id/properties'
    | '/app/trusts/$id/companies'
    | '/app/trusts/$id/assets'
    | '/app/trusts/$id/companies/$companyId'
    | '/app/trusts/$id/meetings'
    | '/app/trusts/$id/meetings/new'
    | '/app/trusts/$id/loa-low'
    | '/app/trusts/$id/risk-rating'
    | '/app/trusts/$id/settings'
    | '/app/trusts/$id/people'
    | '/app/trusts/$id/beneficiaries'
    | '/app/trusts/$id/beneficial-ownership'
    | '/app/trusts/$id/resolutions'
    | '/app/trusts/$id/resolutions/$rid/sign'
    | '/app/trusts/$id/resolutions/$rid'
    | '/app/trusts/$id/document-review/$jobId'
    | '/app/trust'
    | '/app/resolutions'
    | '/app/resolutions/$id/sign'
    | '/app/documents'
    | '/app/beneficiaries'
    | '/app/beneficiaries/ownership'
    | '/app/distributions'
    | '/app/tax'
    | '/app/audit'
    | '/app/messages'
    | '/superadmin/'
    | '/superadmin/tiers'
    | '/superadmin/recovery'
    | '/superadmin/audit'
    | '/superadmin/subprocessors'
    | '/superadmin/settings'
    | '/superadmin/tenants'
    | '/superadmin/tenants/$id'
    | '/admin/dashboard'
    | '/admin/client-book'
    | '/admin/branding'
    | '/admin/clients'
    | '/admin/clients/$id'
    | '/admin/team'
    | '/admin/billing'
    | '/admin/partner-earnings'
    | '/admin/integrations'
    | '/admin/audit'
    | '/admin/entity-graph'
    | '/admin/dsar'
    | '/admin/compliance-reports'
    | '/admin/recovery-requests'
    | '/admin/external-auditors'
    | '/admin/master-lodgements'
    | '/admin/document-coverage'
    | '/admin/documents'
    | '/admin/fic-reports'
    | '/admin/fic-reports/new'
    | '/admin/fic-reports/$id'
    | '/admin/risk-review'
    | '/admin/edd'
    | '/admin/edd/$id'
    | '/admin/aes-sync-log'
    | '/admin/legal-holds'
    | '/admin/branding/custom-domain'
    | '/admin/queue'
    | '/admin/trusts'
    | '/admin/fica'
    | '/superadmin/sentinel-rules'
    | '/superadmin/health'
    | '/superadmin/pricing'
    | '/superadmin/features'
    | '/onboarding/firm'
    | '/onboarding/individual'
    | '/onboarding/invited'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/pricing'
    | '/contact'
    | '/help'
    | '/product'
    | '/security'
    | '/customers'
    | '/status'
    | '/changelog'
    | '/careers'
    | '/docs'
    | '/docs/getting-started'
    | '/docs/onboarding-a-trust'
    | '/docs/signing-flow'
    | '/brandbook'
    | '/firms'
    | '/app'
    | '/superadmin'
    | '/admin'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/forgot'
    | '/auth/reset-password'
    | '/auth/check-email'
    | '/auth/workspace-invite'
    | '/auth/recovery'
    | '/auth/recovery/lost-both'
    | '/auth/recovery/status'
    | '/sign/external/$token'
    | '/sign/external/return'
    | '/auth/mfa-enroll'
    | '/auth/mfa-verify'
    | '/auth/refresh-step-up'
    | '/legal/privacy'
    | '/legal/paia'
    | '/legal/terms'
    | '/partner/finder-dashboard'
    | '/legal/cookies'
    | '/legal/trust-centre'
    | '/legal/subprocessors'
    | '/legal/security'
    | '/legal/dpa'
    | '/compliance'
    | '/compliance/fica'
    | '/compliance/popia'
    | '/audit'
    | '/audit/'
    | '/audit/$trustId'
    | '/app/dashboard'
    | '/app/structure'
    | '/app/inbox'
    | '/app/security'
    | '/app/firm-access'
    | '/app/profile'
    | '/app/privacy'
    | '/app/trusts/'
    | '/app/trusts/$id/'
    | '/app/trusts/$id/distributions'
    | '/app/trusts/$id/tax'
    | '/app/trusts/$id/audit'
    | '/app/trusts/$id/documents'
    | '/app/trusts/$id/portfolios'
    | '/app/trusts/$id/properties'
    | '/app/trusts/$id/companies'
    | '/app/trusts/$id/assets'
    | '/app/trusts/$id/companies/$companyId'
    | '/app/trusts/$id/meetings'
    | '/app/trusts/$id/meetings/new'
    | '/app/trusts/$id/loa-low'
    | '/app/trusts/$id/risk-rating'
    | '/app/trusts/$id/settings'
    | '/app/trusts/$id/people/'
    | '/app/trusts/$id/beneficiaries/'
    | '/app/trusts/$id/beneficial-ownership'
    | '/app/trusts/$id/resolutions/'
    | '/app/trusts/$id/resolutions/$rid/sign'
    | '/app/trusts/$id/resolutions/$rid/'
    | '/app/trusts/$id/document-review/$jobId'
    | '/app/trust'
    | '/app/resolutions/'
    | '/app/resolutions/$id/sign'
    | '/app/documents'
    | '/app/beneficiaries/'
    | '/app/beneficiaries/ownership'
    | '/app/distributions'
    | '/app/tax'
    | '/app/audit'
    | '/app/messages'
    | '/superadmin/'
    | '/superadmin/tiers'
    | '/superadmin/recovery'
    | '/superadmin/audit'
    | '/superadmin/subprocessors'
    | '/superadmin/settings'
    | '/superadmin/tenants/'
    | '/superadmin/tenants/$id'
    | '/admin/dashboard'
    | '/admin/client-book'
    | '/admin/branding'
    | '/admin/clients/'
    | '/admin/clients/$id'
    | '/admin/team'
    | '/admin/billing'
    | '/admin/partner-earnings'
    | '/admin/integrations'
    | '/admin/audit'
    | '/admin/entity-graph'
    | '/admin/dsar'
    | '/admin/compliance-reports'
    | '/admin/recovery-requests'
    | '/admin/external-auditors'
    | '/admin/master-lodgements'
    | '/admin/document-coverage'
    | '/admin/documents'
    | '/admin/fic-reports'
    | '/admin/fic-reports/new'
    | '/admin/fic-reports/$id'
    | '/admin/risk-review'
    | '/admin/edd'
    | '/admin/edd/$id'
    | '/admin/aes-sync-log'
    | '/admin/legal-holds'
    | '/admin/branding/custom-domain'
    | '/admin/queue'
    | '/admin/trusts'
    | '/admin/fica'
    | '/superadmin/sentinel-rules'
    | '/superadmin/health'
    | '/superadmin/pricing'
    | '/superadmin/features'
    | '/onboarding/firm'
    | '/onboarding/individual'
    | '/onboarding/invited'
  fileRoutesById: FileRoutesById
}

export interface ComplianceRouteChildren {
  ComplianceFicaRoute: typeof ComplianceFicaRoute
  CompliancePopiaRoute: typeof CompliancePopiaRoute
}

export interface AuditRouteChildren {
  AuditIndexRoute: typeof AuditIndexRoute
  AuditTrustIdRoute: typeof AuditTrustIdRoute
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  PricingRoute: typeof PricingRoute
  ContactRoute: typeof ContactRoute
  HelpRoute: typeof HelpRoute
  ProductRoute: typeof ProductRoute
  SecurityRoute: typeof SecurityRoute
  CustomersRoute: typeof CustomersRoute
  StatusRoute: typeof StatusRoute
  ChangelogRoute: typeof ChangelogRoute
  CareersRoute: typeof CareersRoute
  DocsRoute: typeof DocsRoute
  DocsGettingStartedRoute: typeof DocsGettingStartedRoute
  DocsOnboardingTrustRoute: typeof DocsOnboardingTrustRoute
  DocsSigningFlowRoute: typeof DocsSigningFlowRoute
  BrandbookRoute: typeof BrandbookRoute
  FirmsRoute: typeof FirmsRoute
  AppRoute: typeof AppRoute
  SuperAdminRoute: typeof SuperAdminRoute
  AdminRoute: typeof AdminRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthWorkspaceInviteRoute: typeof AuthWorkspaceInviteRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthRecoveryRoute: typeof AuthRecoveryRoute
  AuthRecoveryLostBothRoute: typeof AuthRecoveryLostBothRoute
  AuthRecoveryStatusRoute: typeof AuthRecoveryStatusRoute
  SignExternalTokenRoute: typeof SignExternalTokenRoute
  SignExternalReturnRoute: typeof SignExternalReturnRoute
  AuthMfaEnrollRoute: typeof AuthMfaEnrollRoute
  AuthMfaVerifyRoute: typeof AuthMfaVerifyRoute
  AuthRefreshStepUpRoute: typeof AuthRefreshStepUpRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
  LegalPaiaRoute: typeof LegalPaiaRoute
  LegalTermsRoute: typeof LegalTermsRoute
  PartnerFinderDashboardRoute: typeof PartnerFinderDashboardRoute
  LegalCookiesRoute: typeof LegalCookiesRoute
  LegalTrustCentreRoute: typeof LegalTrustCentreRoute
  LegalSubprocessorsRoute: typeof LegalSubprocessorsRoute
  LegalSecurityRoute: typeof LegalSecurityRoute
  LegalDpaRoute: typeof LegalDpaRoute
  ComplianceRoute: typeof ComplianceRoute
  AuditRoute: typeof AuditRoute
  OnboardingFirmRoute: typeof OnboardingFirmRoute
  OnboardingIndividualRoute: typeof OnboardingIndividualRoute
  OnboardingInvitedRoute: typeof OnboardingInvitedRoute
}

export interface AdminRouteChildren {
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminClientBookRoute: typeof AdminClientBookRoute
  AdminBrandingRoute: typeof AdminBrandingRoute
  AdminClientsIndexRoute: typeof AdminClientsIndexRoute
  AdminClientsIdRoute: typeof AdminClientsIdRoute
  AdminTeamRoute: typeof AdminTeamRoute
  AdminBillingRoute: typeof AdminBillingRoute
  AdminPartnerEarningsRoute: typeof AdminPartnerEarningsRoute
  AdminIntegrationsRoute: typeof AdminIntegrationsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminEntityGraphRoute: typeof AdminEntityGraphRoute
  AdminDsarRoute: typeof AdminDsarRoute
  AdminComplianceReportsRoute: typeof AdminComplianceReportsRoute
  AdminRecoveryRequestsRoute: typeof AdminRecoveryRequestsRoute
  AdminExternalAuditorsRoute: typeof AdminExternalAuditorsRoute
  AdminMasterLodgementsRoute: typeof AdminMasterLodgementsRoute
  AdminDocumentCoverageRoute: typeof AdminDocumentCoverageRoute
  AdminDocumentsRoute: typeof AdminDocumentsRoute
  AdminFicReportsRoute: typeof AdminFicReportsRoute
  AdminFicReportsNewRoute: typeof AdminFicReportsNewRoute
  AdminFicReportsIdRoute: typeof AdminFicReportsIdRoute
  AdminRiskReviewRoute: typeof AdminRiskReviewRoute
  AdminEddRoute: typeof AdminEddRoute
  AdminEddIdRoute: typeof AdminEddIdRoute
  AdminAesSyncLogRoute: typeof AdminAesSyncLogRoute
  AdminLegalHoldsRoute: typeof AdminLegalHoldsRoute
  AdminBrandingCustomDomainRoute: typeof AdminBrandingCustomDomainRoute
  AdminQueueRoute: typeof AdminQueueRoute
  AdminTrustsRoute: typeof AdminTrustsRoute
  AdminFicaRoute: typeof AdminFicaRoute
}

export interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppStructureRoute: typeof AppStructureRoute
  AppInboxRoute: typeof AppInboxRoute
  AppSecurityRoute: typeof AppSecurityRoute
  AppFirmAccessRoute: typeof AppFirmAccessRoute
  AppProfileRoute: typeof AppProfileRoute
  AppPrivacyRoute: typeof AppPrivacyRoute
  AppTrustsIndexRoute: typeof AppTrustsIndexRoute
  AppTrustsIdIndexRoute: typeof AppTrustsIdIndexRoute
  AppTrustsIdDistributionsRoute: typeof AppTrustsIdDistributionsRoute
  AppTrustsIdTaxRoute: typeof AppTrustsIdTaxRoute
  AppTrustsIdAuditRoute: typeof AppTrustsIdAuditRoute
  AppTrustsIdDocumentsRoute: typeof AppTrustsIdDocumentsRoute
  AppTrustsIdPortfoliosRoute: typeof AppTrustsIdPortfoliosRoute
  AppTrustsIdPropertiesRoute: typeof AppTrustsIdPropertiesRoute
  AppTrustsIdCompaniesRoute: typeof AppTrustsIdCompaniesRoute
  AppTrustsIdAssetsRoute: typeof AppTrustsIdAssetsRoute
  AppTrustsIdCompaniesCompanyIdRoute: typeof AppTrustsIdCompaniesCompanyIdRoute
  AppTrustsIdMeetingsRoute: typeof AppTrustsIdMeetingsRoute
  AppTrustsIdMeetingsNewRoute: typeof AppTrustsIdMeetingsNewRoute
  AppTrustsIdLoaLowRoute: typeof AppTrustsIdLoaLowRoute
  AppTrustsIdRiskRatingRoute: typeof AppTrustsIdRiskRatingRoute
  AppTrustsIdSettingsRoute: typeof AppTrustsIdSettingsRoute
  AppTrustsIdPeopleIndexRoute: typeof AppTrustsIdPeopleIndexRoute
  AppTrustsIdBeneficiariesIndexRoute: typeof AppTrustsIdBeneficiariesIndexRoute
  AppTrustsIdBeneficiaryOwnershipRoute: typeof AppTrustsIdBeneficiaryOwnershipRoute
  AppTrustsIdResolutionsIndexRoute: typeof AppTrustsIdResolutionsIndexRoute
  AppTrustsIdResolutionsRidSignRoute: typeof AppTrustsIdResolutionsRidSignRoute
  AppTrustsIdDocumentReviewJobIdRoute: typeof AppTrustsIdDocumentReviewJobIdRoute
  AppTrustsIdResolutionsRidIndexRoute: typeof AppTrustsIdResolutionsRidIndexRoute
  AppTrustRoute: typeof AppTrustRoute
  AppResolutionsIndexRoute: typeof AppResolutionsIndexRoute
  AppResolutionsIdSignRoute: typeof AppResolutionsIdSignRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppBeneficiariesIndexRoute: typeof AppBeneficiariesIndexRoute
  AppBeneficiariesOwnershipRoute: typeof AppBeneficiariesOwnershipRoute
  AppDistributionsRoute: typeof AppDistributionsRoute
  AppTaxRoute: typeof AppTaxRoute
  AppAuditRoute: typeof AppAuditRoute
  AppMessagesRoute: typeof AppMessagesRoute
}

export interface SuperAdminRouteChildren {
  SuperAdminIndexRoute: typeof SuperAdminIndexRoute
  SuperAdminTiersRoute: typeof SuperAdminTiersRoute
  SuperAdminRecoveryRoute: typeof SuperAdminRecoveryRoute
  SuperAdminAuditRoute: typeof SuperAdminAuditRoute
  SuperAdminSubprocessorsRoute: typeof SuperAdminSubprocessorsRoute
  SuperAdminSettingsRoute: typeof SuperAdminSettingsRoute
  SuperAdminTenantsIndexRoute: typeof SuperAdminTenantsIndexRoute
  SuperAdminTenantsIdRoute: typeof SuperAdminTenantsIdRoute
  SuperAdminSentinelRulesRoute: typeof SuperAdminSentinelRulesRoute
  SuperAdminHealthRoute: typeof SuperAdminHealthRoute
  SuperAdminPricingRoute: typeof SuperAdminPricingRoute
  SuperAdminFeaturesRoute: typeof SuperAdminFeaturesRoute
}

const appRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppStructureRoute: AppStructureRoute,
  AppInboxRoute: AppInboxRoute,
  AppSecurityRoute: AppSecurityRoute,
  AppFirmAccessRoute: AppFirmAccessRoute,
  AppProfileRoute: AppProfileRoute,
  AppPrivacyRoute: AppPrivacyRoute,
  AppTrustsIndexRoute: AppTrustsIndexRoute,
  AppTrustsIdIndexRoute: AppTrustsIdIndexRoute,
  AppTrustsIdDistributionsRoute: AppTrustsIdDistributionsRoute,
  AppTrustsIdTaxRoute: AppTrustsIdTaxRoute,
  AppTrustsIdCompaniesRoute: AppTrustsIdCompaniesRoute,
  AppTrustsIdAssetsRoute: AppTrustsIdAssetsRoute,
  AppTrustsIdCompaniesCompanyIdRoute: AppTrustsIdCompaniesCompanyIdRoute,
  AppTrustsIdPropertiesRoute: AppTrustsIdPropertiesRoute,
  AppTrustsIdAuditRoute: AppTrustsIdAuditRoute,
  AppTrustsIdDocumentsRoute: AppTrustsIdDocumentsRoute,
  AppTrustsIdPortfoliosRoute: AppTrustsIdPortfoliosRoute,
  AppTrustsIdMeetingsRoute: AppTrustsIdMeetingsRoute,
  AppTrustsIdMeetingsNewRoute: AppTrustsIdMeetingsNewRoute,
  AppTrustsIdLoaLowRoute: AppTrustsIdLoaLowRoute,
  AppTrustsIdRiskRatingRoute: AppTrustsIdRiskRatingRoute,
  AppTrustsIdSettingsRoute: AppTrustsIdSettingsRoute,
  AppTrustsIdPeopleIndexRoute: AppTrustsIdPeopleIndexRoute,
  AppTrustsIdBeneficiariesIndexRoute: AppTrustsIdBeneficiariesIndexRoute,
  AppTrustsIdBeneficiaryOwnershipRoute: AppTrustsIdBeneficiaryOwnershipRoute,
  AppTrustsIdResolutionsIndexRoute: AppTrustsIdResolutionsIndexRoute,
  AppTrustsIdResolutionsRidSignRoute: AppTrustsIdResolutionsRidSignRoute,
  AppTrustsIdDocumentReviewJobIdRoute: AppTrustsIdDocumentReviewJobIdRoute,
  AppTrustsIdResolutionsRidIndexRoute: AppTrustsIdResolutionsRidIndexRoute,
  AppTrustRoute: AppTrustRoute,
  AppResolutionsIndexRoute: AppResolutionsIndexRoute,
  AppResolutionsIdSignRoute: AppResolutionsIdSignRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppBeneficiariesIndexRoute: AppBeneficiariesIndexRoute,
  AppBeneficiariesOwnershipRoute: AppBeneficiariesOwnershipRoute,
  AppDistributionsRoute: AppDistributionsRoute,
  AppTaxRoute: AppTaxRoute,
  AppAuditRoute: AppAuditRoute,
  AppMessagesRoute: AppMessagesRoute,
}

const superAdminRouteChildren: SuperAdminRouteChildren = {
  SuperAdminIndexRoute: SuperAdminIndexRoute,
  SuperAdminTiersRoute: SuperAdminTiersRoute,
  SuperAdminRecoveryRoute: SuperAdminRecoveryRoute,
  SuperAdminAuditRoute: SuperAdminAuditRoute,
  SuperAdminSubprocessorsRoute: SuperAdminSubprocessorsRoute,
  SuperAdminSettingsRoute: SuperAdminSettingsRoute,
  SuperAdminTenantsIndexRoute: SuperAdminTenantsIndexRoute,
  SuperAdminTenantsIdRoute: SuperAdminTenantsIdRoute,
  SuperAdminSentinelRulesRoute: SuperAdminSentinelRulesRoute,
  SuperAdminHealthRoute: SuperAdminHealthRoute,
  SuperAdminPricingRoute: SuperAdminPricingRoute,
  SuperAdminFeaturesRoute: SuperAdminFeaturesRoute,
}

const adminRouteChildren: AdminRouteChildren = {
  AdminDashboardRoute: AdminDashboardRoute,
  AdminClientBookRoute: AdminClientBookRoute,
  AdminBrandingRoute: AdminBrandingRoute,
  AdminClientsIndexRoute: AdminClientsIndexRoute,
  AdminClientsIdRoute: AdminClientsIdRoute,
  AdminTeamRoute: AdminTeamRoute,
  AdminBillingRoute: AdminBillingRoute,
  AdminPartnerEarningsRoute: AdminPartnerEarningsRoute,
  AdminIntegrationsRoute: AdminIntegrationsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminEntityGraphRoute: AdminEntityGraphRoute,
  AdminDsarRoute: AdminDsarRoute,
  AdminComplianceReportsRoute: AdminComplianceReportsRoute,
  AdminRecoveryRequestsRoute: AdminRecoveryRequestsRoute,
  AdminExternalAuditorsRoute: AdminExternalAuditorsRoute,
  AdminMasterLodgementsRoute: AdminMasterLodgementsRoute,
  AdminDocumentCoverageRoute: AdminDocumentCoverageRoute,
  AdminDocumentsRoute: AdminDocumentsRoute,
  AdminFicReportsRoute: AdminFicReportsRoute,
  AdminFicReportsNewRoute: AdminFicReportsNewRoute,
  AdminFicReportsIdRoute: AdminFicReportsIdRoute,
  AdminRiskReviewRoute: AdminRiskReviewRoute,
  AdminEddRoute: AdminEddRoute,
  AdminEddIdRoute: AdminEddIdRoute,
  AdminAesSyncLogRoute: AdminAesSyncLogRoute,
  AdminLegalHoldsRoute: AdminLegalHoldsRoute,
  AdminBrandingCustomDomainRoute: AdminBrandingCustomDomainRoute,
  AdminQueueRoute: AdminQueueRoute,
  AdminTrustsRoute: AdminTrustsRoute,
  AdminFicaRoute: AdminFicaRoute,
}

const complianceRouteChildren: ComplianceRouteChildren = {
  ComplianceFicaRoute: ComplianceFicaRoute,
  CompliancePopiaRoute: CompliancePopiaRoute,
}

const auditRouteChildren: AuditRouteChildren = {
  AuditIndexRoute: AuditIndexRoute,
  AuditTrustIdRoute: AuditTrustIdRoute,
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  PricingRoute: PricingRoute,
  ContactRoute: ContactRoute,
  HelpRoute: HelpRoute,
  ProductRoute: ProductRoute,
  SecurityRoute: SecurityRoute,
  CustomersRoute: CustomersRoute,
  StatusRoute: StatusRoute,
  ChangelogRoute: ChangelogRoute,
  CareersRoute: CareersRoute,
  DocsRoute: DocsRoute,
  DocsGettingStartedRoute: DocsGettingStartedRoute,
  DocsOnboardingTrustRoute: DocsOnboardingTrustRoute,
  DocsSigningFlowRoute: DocsSigningFlowRoute,
  BrandbookRoute: BrandbookRoute,
  FirmsRoute: FirmsRoute,
  AppRoute: AppRoute._addFileChildren(appRouteChildren),
  SuperAdminRoute: SuperAdminRoute._addFileChildren(superAdminRouteChildren),
  AdminRoute: AdminRoute._addFileChildren(adminRouteChildren),
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthWorkspaceInviteRoute: AuthWorkspaceInviteRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthRecoveryRoute: AuthRecoveryRoute,
  AuthRecoveryLostBothRoute: AuthRecoveryLostBothRoute,
  AuthRecoveryStatusRoute: AuthRecoveryStatusRoute,
  SignExternalTokenRoute: SignExternalTokenRoute,
  SignExternalReturnRoute: SignExternalReturnRoute,
  AuthMfaEnrollRoute: AuthMfaEnrollRoute,
  AuthMfaVerifyRoute: AuthMfaVerifyRoute,
  AuthRefreshStepUpRoute: AuthRefreshStepUpRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
  LegalPaiaRoute: LegalPaiaRoute,
  LegalTermsRoute: LegalTermsRoute,
  PartnerFinderDashboardRoute: PartnerFinderDashboardRoute,
  LegalCookiesRoute: LegalCookiesRoute,
  LegalTrustCentreRoute: LegalTrustCentreRoute,
  LegalSubprocessorsRoute: LegalSubprocessorsRoute,
  LegalSecurityRoute: LegalSecurityRoute,
  LegalDpaRoute: LegalDpaRoute,
  ComplianceRoute: ComplianceRoute._addFileChildren(complianceRouteChildren),
  AuditRoute: AuditRoute._addFileChildren(auditRouteChildren),
  OnboardingFirmRoute: OnboardingFirmRoute,
  OnboardingIndividualRoute: OnboardingIndividualRoute,
  OnboardingInvitedRoute: OnboardingInvitedRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
